(function() {
    'use strict';
    var controllerId = 'productCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', '$modal', '$routeParams', 'NgTableParams', productCtrl]);
    function productCtrl(common, datacontext, $scope, $location, $modal, $routeParams, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        var vm = this;
        vm.startSearch = 0;
        vm.products = [];
        vm.search_text = "";
        vm.title = 'Product List View';
        $scope.save_search_edit = 0;
        $scope.productsource_id = 0;
		
        vm.query = {
            queryType:'array-count',
            search:'',
            image_status_id:'',
            canvas_image_status_id:'',
            price_status_id:'',
            description_status_id:'',
            category_status_id:'',
            relationship_status_id:'',
            asin_complete:'',
            asin_iscomplete_uk:'',
            special_audit:'',
            asin_iscomplete_ca:'',
            has_price:'',
            has_cogs:'',
            has_asin:'',
            has_upc:'',
            in_stock:'4',
            is_fit_to_sell:'',
            is_orderable:'',
            is_active:'',
            is_active_override:'1',
            category_id:'13',
            has_active_store_products:'',
            mp_1_audit_bucket:'',
            mp_uk_audit_bucket:'',
            order_by:'sales_last_10_days',
            order_dir:'desc',
            has_orphan:'',
            is_print_on_demand:'',
            is_phantom:'',
            amazon_spid_count: '',
            amazon_uk_spid_count:'',
            ebay_spid_count: '',
            walmart_spid_count:'',
            sort_by:'',
            shipping_region_id:'',
            product_license_region_id:'',
            search_category:2,
            parent:'',
            is_price_rule_locked:'',
            page:1,
            limit:20
        };

        //add url variables search
        if(angular.isDefined($routeParams.lowstock)){
        	vm.query.stock_level = 2;
        	vm.query.pod_dimension_id = 1;
        	vm.query.is_phantom = 0;
        	vm.query.is_orderable = 1;
        	vm.query.is_active_override = 1;
        }

        // selectively update
        vm.urlQuery  = $location.search();
        var url_used = 0;

        // loop and set url var
        for ( var i in vm.urlQuery ){
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }
            url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {

            for ( var i in newValue ) {
                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                    vm.startSearch ++;
                    if( oldValue[i] >= 0 || oldValue[i] == "" || oldValue[i] < 0 || angular.isUndefined(oldValue[i])  == true ){

                        if( i === 'save_search_list'){
                            get_products_list_save_search();
                        }else{
                            get_products_list();
                        }

                    }else{
                        return "";
                    }

                }
            }

        });

        activate();

        function activate() {
            if(angular.isDefined($routeParams.search_id)){
                vm.query.save_search_list = $routeParams.search_id;
                var promises = [
                    get_products_list_save_search(),
                    getProductCategories(),
                    getManufacturers(),
                    getProductStatus(),
                    getProductOrientations(),
                    getProductSource(),
                    get_product_save_search(),
                    get_price_rules(),
                    get_shipping_regions(),
                    get_license_region_list(),
                    get_content_themes_list(),
                    get_product_pod_dimensions()];

            }else{
                var promises = [
                    get_products_list(),
                    getProductCategories(),
                    getManufacturers(),
                    getProductStatus(),
                    getProductOrientations(),
                    getProductSource(),
                    get_product_save_search(),
                    get_price_rules(),
                    get_shipping_regions(),
                    get_license_region_list(),
                    get_content_themes_list(),
                    get_product_pod_dimensions()];
            }


            common.activateController(promises, controllerId)
                .then(function() {
                    //  log('Activated Product List View');
                });
        }

        function getProductCategories() {
            return datacontext.get_product_categories().then(function (httpResult) {
                $scope.product_categories = httpResult.data;
                Console.log("Product Categories testing");
            });
        }
        function get_content_themes_list() {
            return datacontext.get_content_themes_list().then(function (httpResult) {
                vm.content_themes = httpResult.data;
            });
        }
        function getProductStatus() {
            return datacontext.get_product_status().then(function (httpResult) {
                vm.product_status = httpResult.data.data;
            });
        }

        function getProductOrientations() {
            return datacontext.get_product_orientation().then(function (httpResult) {
                vm.product_orientation = httpResult.data;
            });
        }

        function getProductSource() {
            return datacontext.get_product_source().then(function (httpResult) {
                vm.product_source = httpResult.data.data;
            });
        }

        function getManufacturers() {
            return datacontext.get_manufacturers().then(function (httpResult) {
                $scope.manufacturers = httpResult.data;
            });
        }

        function get_product_save_search() {
            var data = {};
            data.search_category = 2;

            return datacontext.get_product_save_search(data).then(function (httpResult) {
                vm.save_search_list = httpResult.data.data;
            });
        }

        function get_price_rules() {
            return datacontext.get_price_rules().then(function(httpResult) {
                $scope.price_rules = httpResult.data.data;
            });
        }

        function get_product_pod_dimensions() {
            return datacontext.get_product_pod_dimensions().then(function (httpResult) {
                vm.pod_dimensions = httpResult.data.data;
            });
        }

        function get_shipping_regions() {
            return datacontext.get_shipping_regions().then(function (httpResult) {
                vm.shipping_regions = httpResult.data.data;
            });
        }

        function get_license_region_list() {
            return datacontext.get_license_region_list().then(function (httpResult) {
                vm.product_license_regions = httpResult.data;
            });
        }

        function get_products_list_save_search() {
             var data = {
                search_id: vm.query.save_search_list,
                search_category:2
             };

             //return "";
            return datacontext.get_product_save_search(data).then(function(httpResult) {
                vm.save_search_data = httpResult.data.data;

                console.log(vm.save_search_data);

                if(httpResult.data.RECORDCOUNT === 1){

                    sort_by(vm.save_search_data[0].sort_by);

                    vm.query.asin_complete = vm.save_search_data[0].asin_complete.toString();
                    vm.query.asin_iscomplete_uk = vm.save_search_data[0].asin_iscomplete_uk.toString();
                    //vm.query.special_audit = vm.save_search_data[0].special_audit.toString();
                    vm.query.asin_iscomplete_ca = vm.save_search_data[0].asin_iscomplete_ca.toString();
                    //vm.query.category_status_id = vm.save_search_data[0].category_status_id.toString();
                    vm.query.description_status_id = vm.save_search_data[0].description_status_id.toString();
                    vm.query.has_active_store_products = vm.save_search_data[0].has_active_store_products.toString();
                    //vm.query.has_asin = vm.save_search_data[0].has_asin.toString();
                    vm.query.pod_dimension_id = vm.save_search_data[0].pod_dimension_id.toString();
                    vm.query.has_cogs = vm.save_search_data[0].has_cogs.toString();
                    vm.query.sales_bucket = vm.save_search_data[0].sales_bucket.toString();
                    vm.query.stock_level = vm.save_search_data[0].stock_level.toString();
                    vm.query.is_oversize = vm.save_search_data[0].is_oversize.toString();
                    vm.query.oversell = vm.save_search_data[0].oversell.toString();
                    vm.query.has_orphan = vm.save_search_data[0].has_orphan.toString();
                    vm.query.has_price = vm.save_search_data[0].has_price.toString();
                    vm.query.has_upc = vm.save_search_data[0].has_upc.toString();
                    vm.query.image_status_id = vm.save_search_data[0].image_status_id.toString();
                    vm.query.in_stock = vm.save_search_data[0].in_stock.toString();
                    vm.query.is_active_override = vm.save_search_data[0].is_active_override.toString();
                    vm.query.is_fit_to_sell = vm.save_search_data[0].is_fit_to_sell.toString();
                    vm.query.is_orderable = vm.save_search_data[0].is_orderable.toString();
                    vm.query.is_phantom = vm.save_search_data[0].is_phantom.toString();
                    vm.query.category_id = vm.save_search_data[0].category_id.toString();
                    vm.query.mp_1_audit_bucket = vm.save_search_data[0].mp_1_audit_bucket.toString();
                    vm.query.mp_uk_audit_bucket = vm.save_search_data[0].mp_uk_audit_bucket.toString();
                    vm.query.manufacturer_id = vm.save_search_data[0].manufacturer_id.toString();
                    vm.query.relationship_status_id = vm.save_search_data[0].relationship_status_id.toString();
                    vm.query.product_lead_time = vm.save_search_data[0].product_lead_time.toString();
                    vm.query.search_name = vm.save_search_data[0].search_name.toString();
                    vm.query.amazon_spid_count = vm.save_search_data[0].amazon_spid_count.toString();
                    vm.query.amazon_uk_spid_count = vm.save_search_data[0].amazon_uk_spid_count.toString();
                    vm.query.ebay_spid_count = vm.save_search_data[0].ebay_spid_count.toString();
                    vm.query.walmart_spid_count = vm.save_search_data[0].walmart_spid_count.toString();
                    vm.query.sort_by = vm.save_search_data[0].sort_by.toString();
                    vm.query.product_source_id = vm.save_search_data[0].product_source_id.toString();
                    vm.query.shipping_region_id = vm.save_search_data[0].shipping_region_id.toString();
                    vm.query.product_license_region_id = vm.save_search_data[0].product_license_region_id.toString();
                    vm.query.oos_date = vm.save_search_data[0].oos_date.toString();
                    vm.query.restock_date = vm.save_search_data[0].restock_date.toString();
                    vm.query.is_price_rule_locked = vm.save_search_data[0].is_price_rule_locked.toString();


                    vm.query.order_by = 'sales_last_10_days';
                    vm.query.order_dir = 'desc';
                    vm.query.page = 1;
                    vm.query.limit = 20;

                }else{
                    vm.query = {
                        queryType:'array-count',
                        search:'',
                        image_status_id:'',
                        price_status_id:'',
                        description_status_id:'',
                        category_status_id:'',
                        relationship_status_id:'',
                        asin_complete:'',
                        asin_iscomplete_uk:'',
                        special_audit:'',
                        asin_iscomplete_ca:'',
                        has_price:'',
                        has_cogs:'',
                        has_asin:'',
                        has_upc:'',
                        in_stock:'',
                        is_fit_to_sell:'',
                        is_orderable:'',
                        is_active:'',
                        is_active_override:'',
                        has_active_store_products:'',
                        mp_1_audit_bucket:'',
                        mp_uk_audit_bucket:'',
                        order_by:'sales_last_10_days',
                        order_dir:'desc',
                        has_orphan:'',
                        is_print_on_demand:'',
                        is_phantom:'',
                        amazon_spid_count: '',
                        amazon_uk_spid_count: '',
                        ebay_spid_count: '',
                        walmart_spid_count:'',
                        search_category:2,
                        product_source_id:'',
                        shipping_region_id:'',
                        product_license_region_id:'',
                        is_price_rule_locked:'',
                        sort_by:'',
                        page:1,
                        limit:20
                    };

                    get_products_list();
                }

            });
        }

        function sort_by(idx) {

            switch(idx) {
                case '1':
                    vm.query.order_by = 'product_id';
                    vm.query.order_dir = 'asc';
                    break;
                case '2':
                    vm.query.order_by = 'product_id';
                    vm.query.order_dir = 'desc';
                    break;
                case '3':
                    vm.query.order_by = 'vendor_sku_list';
                    vm.query.order_dir = 'asc';
                    break;
                case '4':
                    vm.query.order_by = 'vendor_sku_list';
                    vm.query.order_dir = 'desc';
                    break;
                case '5':
                    vm.query.order_by = 'product_title';
                    vm.query.order_dir = 'asc';
                    break;
                case '6':
                    vm.query.order_by = 'product_title';
                    vm.query.order_dir = 'desc';
                    break;
                case '7':
                    vm.query.order_by = 'width';
                    vm.query.order_dir = 'asc';
                    break;
                case '8':
                    vm.query.order_by = 'width';
                    vm.query.order_dir = 'desc';
                    break;
                case '9':
                    vm.query.order_by = 'height';
                    vm.query.order_dir = 'asc';
                    break;
                case '10':
                    vm.query.order_by = 'height';
                    vm.query.order_dir = 'desc';
                    break;
                case '11':
                    vm.query.order_by = 'qty_to_sell';
                    vm.query.order_dir = 'asc';
                    break;
                case '12':
                    vm.query.order_by = 'qty_to_sell';
                    vm.query.order_dir = 'desc';
                    break;
                case '13':
                    vm.query.order_by = 'sales_last_10_days';
                    vm.query.order_dir = 'asc';
                    break;
                case '14':
                    vm.query.order_by = 'sales_last_10_days';
                    vm.query.order_dir = 'desc';
                    break;
                case '15':
                    vm.query.order_by = 'sales_last_90_days';
                    vm.query.order_dir = 'asc';
                    break;
                case '16':
                    vm.query.order_by = 'sales_last_90_days';
                    vm.query.order_dir = 'desc';
                    break;
                case '17':
                    vm.query.order_by = 'asp_last_10_days';
                    vm.query.order_dir = 'asc';
                    break;
                case '18':
                    vm.query.order_by = 'asp_last_10_days';
                    vm.query.order_dir = 'desc';
                    break;
                case '19':
                    vm.query.order_by = 'avg_cogs';
                    vm.query.order_dir = 'asc';
                    break;
                case '20':
                    vm.query.order_by = 'avg_cogs';
                    vm.query.order_dir = 'desc';
                    break;
                case '21':
                    vm.query.order_by = 'sales_last_30_days_amazon_de';
                    vm.query.order_dir = 'desc';
                    break;
                case '22':
                    vm.query.order_by = 'sales_last_30_days_amazon_ca';
                    vm.query.order_dir = 'desc';
                    break;
                default:
                    vm.query.order_by = 'sales_last_10_days';
                    vm.query.order_dir = 'desc';
                    break;
            }

        }

        function get_products_list() {

            sort_by(vm.query.sort_by);

            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    //vm.query.count = params.count;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query[key] = true;
                        vm.query.order_dir = params.sorting()[key];
                    }
                    log_success("Searching");

                    if(vm.query.product_source_id > 0){
                        $scope.productsource_id = vm.query.product_source_id;

                        console.log($scope.productsource_id);
                        console.log($location.absUrl());
                        //$location.search('product_source_id', vm.query.product_source_id);
                        //$location.url("/product_source_id=" + vm.query.product_source_id);
                    }

                    // ajax request to api
                    return datacontext.get_products_list(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        // set new data
                        log_success(httpResult.data.total+" Results found !!!");
                        vm.results = httpResult.data.data;
                        return httpResult.data.data;
                    });
                }
            });
        }

        $scope.search = function(text) {
          if(text.length){
            vm.query.search = text;
          }else{
            vm.query.search = "";
          }
          get_products_list();
        };

        //save search
        $scope.save_search = function(idx,save_search_edit,search_id) {

            $scope.search = vm.query;
            $scope.search.save_search_edit = save_search_edit;
            $scope.search.search_id = search_id;

            if(save_search_edit){
                datacontext.check_temp_search_products({edit_search_id:search_id}).then(function (httpResult) {

                $scope.search.search_name = httpResult.data.data[0].search_name;
                });
                vm.query.edit_search_id = search_id;
            }

            datacontext.check_temp_search_products(vm.query).then(function (httpResult) {
                vm.check_temp_search = httpResult.data.COUNT;

                if(vm.check_temp_search === 0 || save_search_edit == 1){

                    var modalInstance = $modal.open({
                        templateUrl: '/app/products/partials/save_search.html',
                        controller: 'saveSearchProductsCtrl',
                        windowClass: 'small',
                        resolve: {
                            save_search: function () {
                                return $scope.search;
                            }
                        },
                        backdrop: 'static'
                    }).result.then(function (result) {
                        $scope.$broadcast('refreshAuditLog', 'refresh');
                        get_product_save_search();
                    });
                }else{
                    log_error('Already Saved');
                }

            });

        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'saveSearchProductsCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance', 'save_search', saveSearchProductsCtrl]);

    function saveSearchProductsCtrl(common, datacontext, $scope, $modalInstance, save_search) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        $scope.save_search = save_search;

        if($scope.save_search.save_search_edit){
            $scope.search_name = save_search.search_name;
        }
         // $scope.save_search.search_category = 1;

        var vm = this;

        $scope.ok = function (search_name, search_status, search_status_dashboard) {

            $scope.save_search.search_name = search_name;
            $scope.save_search.search_status = search_status;
	    $scope.save_search.search_status_dashboard = search_status_dashboard;
            if(search_name.length >= 100){
                log_error('Name is too long');
                return "";
            }

            var data = {};
            data.search_name = search_name;
            data.search_category = $scope.save_search.search_category;

            datacontext.check_temp_search_products(data).then(function (httpResult) {

                vm.check_temp_search = httpResult.data.COUNT;
                if(vm.check_temp_search === 0 && $scope.save_search.save_search_edit == 0){

                    datacontext.ins_save_search_products($scope.save_search).then(function (httpResult) {

                        $scope.$broadcast('refreshAuditLog', 'refresh');
                        $modalInstance.close();

                        log_success('Saved');
                    });

                }else if($scope.save_search.save_search_edit == 1){

                    datacontext.update_save_search_products($scope.save_search).then(function (httpResult) {

                        $scope.$broadcast('refreshAuditLog', 'refresh');
                        $modalInstance.close();

                        log_success(httpResult.data.data);
                    });

                }else{
                    log_error('Name already Exists');
                }

            });
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();


(function() {
    'use strict';
    var controllerId = 'productDetailCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$routeParams','$location', '$cookies', '$modal', '$anchorScroll', 'NgTableParams', productDetailCtrl]);

    function productDetailCtrl(common, datacontext, $scope, $routeParams, $location, $cookies, $modal, $anchorScroll, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        var vm = this;
        vm.product = [];
        vm.query = {
            queryType:'array-count',
            product_id:$routeParams.pid,
            order_by:'order_id',
            order_dir:'desc',
            page:1,
            limit:20,
            warehouse_id:''
        };
        vm.product_id = $routeParams.pid;
        $scope.product_id = $routeParams.pid;
        $scope.product_update = 0;
        if( angular.isDefined($cookies.get('user_role_id')) ) {
          vm.user_role_id = $cookies.get('user_role_id');
          console.log("vm.user_role_id:"+vm.user_role_id);
        }


        if(angular.isDefined($routeParams.toaudit)){
        	$scope.toaudit = $routeParams.toaudit;
        }else if(angular.isDefined($routeParams.toatt)){
        	$scope.toatt = $routeParams.toatt;
        }else  if(angular.isDefined($routeParams.tovpids)){
          	$scope.tovpids = $routeParams.tovpids;
        }else if(angular.isDefined($routeParams.addstores)){
        	$scope.addstores = $routeParams.addstores;
        }else if(angular.isDefined($routeParams.todesc)){
        	$scope.todesc = $routeParams.todesc;
        }else if(angular.isDefined($routeParams.tosets)){
        	$scope.tosets = $routeParams.tosets;
        }else if(angular.isDefined($routeParams.manufadded)){
        	$scope.manufadded = $routeParams.manufadded;
        }


        // setting for audit log
        $scope.audit_link_id = $routeParams.pid;
        $scope.audit_type_id = 1;
        $scope.pidPrint = function (product_title,product_id) {

            $scope.pid_print = {
                  product_title: product_title,
                  product_id: product_id};

              var modalInstance = $modal.open({
                  templateUrl: '/app/products/print_pid.html',
                  controller: 'printPidModalCtrl',
                  resolve: {
                      pid_print: function () {
                          return $scope.pid_print;
                      },
                      user_name: function() { return $scope.user_name; }
                  }
              }).result.then(function(result){
                      //$scope.tracking_number = result;
                  });

              vm.cancel = function () {
                  modalInstance.dismiss('cancel');
              };

        };

        $scope.PrintPoster = function (product_title,product_id,width,height,pod_dimension_id,master_product_id,layout,layout_name,user_orientation_id) {
            
            $scope.print_poster = {
                product_title: product_title,
                product_id: product_id,
                width: width,
                height: height,
                pod_dimension_id: pod_dimension_id,
                master_product_id: master_product_id,
                layout: layout,
                layout_name: layout_name,
                user_orientation_id:user_orientation_id
            };

            var modalInstance = $modal.open({
                templateUrl: '/app/products/partials/print_poster.html',
                controller: 'printPosterModalCtrl',
                resolve: {
                    print_poster: function() {
                        return $scope.print_poster;
                    },
                    user_name: function(){ return $scope.user_name;}
                }
            }).result.then(function(result){

            });

            vm.cancel = function() {
                modalInstance.dismiss('cancel');
            };
        };

        vm.title = 'Product Detail View';

        activate();

        function activate() {
            var promises = [
                get_products(),
                getProductStatus(),
                getProductOrientations(),
                getManufacturers(),
                get_product_source_list(),
                get_license_region_list(),
                get_content_themes_list(),
                getProductCategories(),
                get_product_pod_dimensions(),
                get_aws_variation_themes(),
                get_price_rules(),
                get_shipping_regions(),
                getProductSets(),
                get_stores(),
                get_warehouses()
            ];
            common.activateController(promises, controllerId)
                .then(function() {

                });
        }

        // tab refresh
        $scope.refreshProductParentChildCtrl = function() {
            $scope.$broadcast('refreshProductParentChildCtrl', 'refresh');
        };

        // $scope.refreshProductRelationshipsCtrl = function() {
        //     $scope.$broadcast('refreshProductRelationshipsCtrl', 'refresh');
        // };
        $scope.refreshProductAttributesCtrl = function() {
            $scope.$broadcast('refreshProductAttributesCtrl', 'refresh');
        };
        $scope.refreshProductCustomCtrl = function() {
            $scope.$broadcast('refreshProductCustomCtrl', 'refresh');
        };

        $scope.refreshProductSetsCtrl = function() {
            $scope.$broadcast('refreshProductSetsCtrl', 'refresh');
        };

        $scope.refreshProductPricingCtrl = function() {
            $scope.$broadcast('refreshProductPricingCtrl', 'refresh');
        };
        $scope.refreshSales = function(data) {
          console.log(data);
          datacontext.update_sales(vm.query).then(function (httpResult) {

          });
        };

        $scope.refreshProductSalesCtrl = function() {

          //var queryType = 'array-count';
          //get_sales();
          vm.sales_history = [];
          vm.title = 'Order List View';
          vm.tableParams = new NgTableParams({
              count: 20 // count per page
          }, {
              getData: function(params) {
                  vm.query.page = params.page;

                  for(var key in params.sorting()) {
                      vm.query.order_by = key;
                      vm.query.order_dir = params.sorting()[key];
                  }

                  console.log('734');

                  if(vm.query.limit  === 20){
                    vm.query.limit = 90;
                  }

                    var urlParams = $location.search();

                    if (urlParams.fba == "1") {
                        vm.query.store_id = "27";
                    } else if (urlParams.store) {
                        vm.query.store_id = urlParams.store.toString();
                    }
                    
                  // ajax request to api
                  return datacontext.get_product_sale_history(vm.query).then(function (httpResult) {
                      //$scope.search_filter = $location.absUrl() + '?' + $.param($scope.tableParams.$params);
                      //console.log(httpResult.data);

                        vm.stores1 = httpResult.data.stores;
                        var urlParams = $location.search();
                          
                        if (urlParams.fba == "1") {
                            vm.query.store_id = "27";
                        } else if (urlParams.store) {
                            vm.query.store_id = urlParams.store.toString();
                        }

                      var labels = [];
                      var orders_num = [];
                      var total_cnt = [];
                      $scope.ageData = [];
                      vm.sales = httpResult.data.sales;
                      var cnt = 0;
                      for ( var i in vm.sales ) {
                        labels.push(vm.sales[i].ordered_on.toString() + '');

                        orders_num.push(vm.sales[i].toral_amt_per_day);
                        total_cnt.push(vm.sales[i].totals_per_day);
                        cnt = cnt+1;
                      }
                      $scope.series = ["total_sales","total_cnt"];
                      $scope.ageLabels = labels;
                      $scope.ageData.push(orders_num);
                      $scope.ageData.push(total_cnt);

                      params.total(httpResult.data.total);
                      vm.results_total = httpResult.data.total;
                      vm.query.page = params.page;
                      // set new data
                      vm.results = httpResult.data.data;
                      $(".sales_history th:nth-child(11)").addClass("fa fa-question-circle");
                      $(".sales_history th:nth-child(11)").attr("title","order total from orders.order_total");
                      return httpResult.data.data;
                  });
              }
          });

        };

        vm.search_query_set = '';
        vm.search_query_store_id = '1';
        vm.active_spids = '';
        vm.search_query_type = '3';

        $scope.search_spids = function(data) {
            var payload = {
                search_query_set:data.search_query_set,
                search_query_store_id:data.search_query_store_id,
                search_query_type: data.search_query_type,
                product_id:$scope.product_id
            };
            
            getProductSets();
            return datacontext.search_spids(payload).then(function(httpResult) {
                vm.results_search = httpResult.data.data;

                if(vm.results_search.length === 0){
                    log_error("Search item is not found in FBM...");
                }

                //getProductAttributes();
            });
        };

        $scope.delete_set = function(data) {
            var payload = {product_subset_spid:data,
                           product_id:$scope.product_id};
            return datacontext.delete_set(payload).then(function(httpResult) {
              vm.results_search = httpResult.data.data;
                getProductSets();
            });
        };

        $scope.update_set = function(product_subset_spid,spid_qty) {
            var payload = {
                product_subset_spid: product_subset_spid,
                product_id:$scope. product_id,
                spid_qty: spid_qty
            };

            return datacontext.update_set(payload).then(function(httpResult) {
                vm.results_search = httpResult.data.data;
                getProductSets();
            });
        };

        $scope.add_spids = function(data) {
            var set_product_ids = '';
            for(var i=0; i < data.length; i++){
              if( set_product_ids.length === 0){
                set_product_ids = data[i];
              }else{
                set_product_ids = set_product_ids +','+data[i];
              }
            }

            var payload = {product_id:$scope.product_id,
                          set_product_ids:set_product_ids};
            return datacontext.add_sets(payload).then(function(httpResult) {
              vm.results_error = httpResult.data;
              if(vm.results_error.length > 0){
                log_error(vm.results_error);
              }else{
                log_success("Set added!");
              }

              getProductSets();
            });
        };

        $scope.sale_history = {
            limit:20
        };
        vm.limit = 20;

        $scope.saleHistoryLimit = function() {
            get_sales();
        };
        $scope.warehousesSelection = function (){
            get_sales();
        };
        $scope.storeSelection = function (){
            get_sales();
        };

        function get_sales(){
            vm.sales_history = [];
            vm.title = 'Order List View';
            vm.tableParams = new NgTableParams({
                count: 20 // count per page
            }, {
                getData: function(params) {
                    vm.query.page = params.page;
                    vm.query.limit = $scope.sale_history.limit;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }
                    console.log('841');

                    // ajax request to api
                    return datacontext.get_product_sale_history(vm.query).then(function (httpResult) {
                        //$scope.search_filter = $location.absUrl() + '?' + $.param($scope.tableParams.$params);
                        //console.log(httpResult.data);
                        vm.stores1 = httpResult.data.stores;
                        var labels = [];
                        var orders_num = [];
                        var total_cnt = [];
                        $scope.ageData = [];
                        vm.sales = httpResult.data.sales;
                        var cnt = 0;
                        for ( var i in vm.sales ) {
                        labels.push(vm.sales[i].ordered_on.toString() + '');

                        orders_num.push(vm.sales[i].toral_amt_per_day);
                        total_cnt.push(vm.sales[i].totals_per_day);
                        cnt = cnt+1;
                        }
                        $scope.series = ["total_sales","total_cnt"];
                        $scope.ageLabels = labels;
                        $scope.ageData.push(orders_num);
                        $scope.ageData.push(total_cnt);

                        params.total(httpResult.data.total);
                        vm.results_total = httpResult.data.total;
                        vm.query.page = params.page;
                        // set new data
                        vm.results = httpResult.data.data;
                        $(".sales_history th:nth-child(11)").addClass("fa fa-question-circle");
                        $(".sales_history th:nth-child(11)").attr("title","order total from orders.order_total");
                        return httpResult.data.data;
                    });
                }
            });
        }

        /*function get_sales(){
          vm.sales_history = [];
          vm.title = 'Order List View';
          vm.query = {
              queryType:'array-count',
              product_id:$routeParams.pid,
              order_by:'order_id',
              order_dir:'desc',
              page:1,
              limit:20
          };

          vm.tableParams = new NgTableParams({
              count: 20 // count per page
          }, {
              getData: function(params) {

                  vm.query.page = params.page;

                  for(var key in params.sorting()) {
                      vm.query.order_by = key;
                      vm.query.order_dir = params.sorting()[key];
                  }

                  console.log('849');

                  // ajax request to api
                  return datacontext.get_product_sale_history(vm.query).then(function (httpResult) {
                      //$scope.search_filter = $location.absUrl() + '?' + $.param($scope.tableParams.$params);
                      params.total(httpResult.data.total);
                      vm.results_total = httpResult.data.total;
                      vm.query.page = params.page;
                      // set new data
                      vm.results = httpResult.data.data;
                      return httpResult.data.data;
                  });
              }
          });

        }*/

        $scope.refresh_storeProductsListCtrl = function() {
            $scope.$broadcast('refresh_storeProductsListCtrl', 'refresh');
        };

        function get_products() {
            var urlParams = $location.search();
            var payload = {
                "product_id":vm.product_id
            };

            return datacontext.get_products(payload).then(function(httpResult) {
                vm.product = httpResult.data.data;
                console.log(httpResult.data);
                $scope.tm_error_msg = httpResult.data.TM_ALERT;
                console.log($scope.tm_error_msg);
                vm.product[0].desc_change = 0;
                $scope.product = httpResult.data.data[0];
                $scope.title_duplicate = httpResult.data.TITLE_DUPLICATE;
                $scope.product.image_sizeInMb = httpResult.data.IMAGESIZEINMB;
                $scope.product.clone_notes = "";
                //$scope.compile_product_title();
                vm.product_title =  $scope.product.product_title;
                $scope.product.product_title = vm.product_title;
                $scope.master_inv_pid =   vm.product[0].master_inv_pid;
                $scope.master_product_id = vm.product[0].master_product_id;
                $scope.newer_version = vm.product[0].newer_version;

                var currentDate = new Date();
                $scope.product.nextYear = currentDate.getFullYear() + 1;

                $scope.clones_notes = vm.product[0].notes;
                if(vm.product[0].notes.indexOf('Cloned from') != -1){
                    $scope.product.old_pid = $scope.clones_notes.match(/(\d+)/i);
                    $scope.product.old_pid_1 = $scope.product.old_pid[0];
                }

                // hardcode todo: move to attribute system.
                /*$scope.product.aws_option_1_type = 'size';
                //$scope.product.aws_option_1_value = $scope.product.height + 'x' +$scope.product.width;
                //$scope.product.aws_option_2_type = 'material';
                vm.aws_option_2_type_list = [
                    {id:'',name: ''},
                    {id:'Framed Paper',name: 'Framed Paper'},
                    {id:'Unframed Paper',name: 'Unframed Paper'},
                    {id:'Stretched Canvas',name: 'Stretched Canvas'},
                    {id:'Framed Gelcoat',name: 'Framed Gelcoat'},
                ];
                */

                // set default
                if (urlParams.tosales == "1") {
                    vm.tab_description_active = false;
                    vm.tab_inventory_active  = false;
                    vm.tab_store_active   = false;
                    vm.tab_pricing_active = false;
                    vm.tab_attr_active  = false;
                    vm.tab_img_active   = false;
                    vm.tab_sets_active  = false;
                    vm.tab_vp_active   = false;
                    vm.tab_sales_active = true;

                    $scope.refreshProductSalesCtrl();
                } else if ( $scope.tosets == 1 ){
                  vm.tab_inventory_active = false;
                  vm.tab_description_active = false;
                  vm.tab_pricing_active = false;
                  vm.tab_store_active = false;
                  vm.tab_sets_active = true;
                  $scope.refreshProductSetsCtrl();
                  var payload = {product_id:$scope.product_id};
                  return datacontext.getProductSets(payload).then(function (httpResult) {
                    vm.productSets = httpResult.data.data;
                    vm.productSetsLength = httpResult.data.LENGTH;
                  });
                } else if( $scope.product.description_status_id == 3 ) {
                	vm.tab_inventory_active = false;
                	vm.tab_description_active = false;
                	vm.tab_pricing_active = true;
                  vm.tab_store_active = false;
                  $scope.refreshProductPricingCtrl();
                }else if(angular.isDefined($cookies.get('default_store')) &&  $scope.todesc != 1) {
    				      vm.tab_inventory_active = false;
                	vm.tab_description_active = false;
                	vm.tab_pricing_active = false;
                	vm.tab_store_active = true;
    		        }else if( $scope.toaudit == 1 ){
                	vm.tab_inventory_active = true;
                	vm.tab_description_active = false;
                	vm.tab_pricing_active = false;
                	vm.tab_store_active = false;

                }else if( $scope.toatt == 1 ){
                	vm.tab_inventory_active = false;
                	vm.tab_description_active = false;
                	vm.tab_pricing_active = false;
                	vm.tab_store_active = false;
                  vm.tab_attr_active = true;
                  $scope.refreshProductAttributesCtrl();
                  // var payload = {product_id:$scope.product_id};
                  // return datacontext.getProductAttributes(payload).then(function (httpResult) {
                  //     vm.productAttributes = httpResult.data.data[0];
                  //     console.log(":here844");
                  //     console.log(vm.productAttributes);
                  // });
                  // return datacontext.get_amazon_subjects().then(function (httpResult) {
                  //   vm.amazon_subjects = httpResult.data.data;
                  // });




                }else if( $scope.tovpids == 1 ){
                	vm.tab_vp_active = true;
                  vm.tab_inventory_active = false;
                	vm.tab_description_active = false;
                	vm.tab_pricing_active = false;
                	vm.tab_store_active = false;

                }else if( $scope.addstores == 1 ){

                   	vm.tab_inventory_active = false;
                   	vm.tab_description_active = false;
                   	vm.tab_pricing_active = false;
                   	vm.tab_store_active = true;

                }else if( $scope.todesc == 1 ){
                   	vm.tab_inventory_active = false;
                   	vm.tab_description_active = true;
                   	vm.tab_pricing_active = false;
                   	vm.tab_store_active = false;

                }else {
                	vm.tab_inventory_active = false;
                  vm.tab_pricing_active = false;
                  vm.tab_description_active = true;
                  vm.tab_store_active = false;

                }

                // Watch Override
                $scope.$watch('product.is_active_override', function(newValue, oldValue) {

                    console.log("new value: " + newValue);
                    console.log("old value: " + oldValue);

                    if (newValue === oldValue) { return; } // AKA first run

                    if (newValue === 1) {
                        $scope.alert_msg_overide = 0;
                    }else {
                        $scope.alert_msg_overide = 1;
                    }
                });

               $scope.$watch(
                   '[product.product_name,product.variant_name,product.category_id,product.width,product.height]',
                    function(newValues, oldValues){
                        if (newValues === oldValues) { return; } // AKA first run

                        // check if user is changing category
                        if (newValues[2] !== oldValues[2]) {

                          for ( var i = 0 ; i < vm.product_categories.length ; i++ ) {
                                    if ( vm.product_categories[i].category_id === newValues[2] ) {
                                        $scope.product.category_id = vm.product_categories[i].category_id;
                                        $scope.product.category_product_display_name = vm.product_categories[i].category_product_display_name;
                                    }
                                }
                            }
                        if (newValues) {
                            $scope.compile_product_title();
                        }

                }, true);

                // Watch Orientation on width change
                $scope.$watch('product.width', function(newValue, oldValue) {
                    if (newValue === oldValue) { return; } // AKA first run
                    if (newValue) {
                        if (newValue > $scope.product.height){
                            $scope.product.orientation = 'landscape';
                        }else if (newValue < $scope.product.height) {
                            $scope.product.orientation = 'portrait';
                        }else {
                            $scope.product.orientation = 'square';
                        }
                    }else {
                    }
                });

                // Watch Orientation on height change
                $scope.$watch('product.height', function(newValue, oldValue) {
                    if (newValue === oldValue) { return; } // AKA first run
                    if (newValue) {
                        if (newValue < $scope.product.width){
                            $scope.product.orientation = 'landscape';
                        }else if (newValue > $scope.product.width) {
                            $scope.product.orientation = 'portrait';
                        }else {
                            $scope.product.orientation = 'square';
                        }
                    }else {
                    }
                });

            });
        }

        // calculate product title
        $scope.compile_product_title = function() {

            // todo: make below less complicated code seems verbose
            vm.product_title =  $scope.product.product_title;

            // if( $scope.product.variant_name.length ) {
            //         vm.product_title =  vm.product_title + ' ' + $scope.product.variant_name;
            // }
            //
            // if($scope.product.category_product_display_name.length !== 0) {
            //     vm.product_title = vm.product_title + ' ' + $scope.product.category_product_display_name;
            // }
            //
            // if($scope.product.show_size_in_title && $scope.product.width > 0 && $scope.product.height > 0){
            //     vm.product_title = vm.product_title + ' - ' + $scope.product.width + 'x' + $scope.product.height;
            // }
            $scope.product.product_title = vm.product_title;
            //$scope.product.ebay_suffix = ' ' + $scope.product.category_product_display_name + ' - ' + $scope.product.width + 'x' + $scope.product.height;


        };

        $scope.allocate_upc = function() {
            // retreive / set upc

           // if ( vm.product[0].upc.length === 0) {}
            datacontext.allocate_upc(vm.product_id).success(function(httpResult) {

                if ( httpResult.success) {
                    vm.product.upc = httpResult.data;
                    get_products();
                } else {
                    // error
                    $scope.upc_error = httpResult.data;
                }
            });
        };

        $scope.allocate_gco_upc = function() {
            // retreive / set upc

           // if ( vm.product[0].upc.length === 0) {}
            datacontext.allocate_gco_upc(vm.product_id).success(function(httpResult) {

                if ( httpResult.success) {
                    vm.product.upc_gco = httpResult.data;
                    get_products();
                } else {
                    // error
                    $scope.upc_error = httpResult.data;
                }
            });
        };


        $scope.update_mp_1_audit_sucess = 0;

        $scope.update_mp_1_audit = function(currentUser) {

            var payload = {
                mp_1_audited_changed:1,
                product_id:$scope.product_id
            };

            datacontext.update_product(payload).then(function() {
                $scope.update_mp_1_audit_sucess = 1;
                // reload product query
                //fake updated
                $scope.product.mp_1_audited_on = moment().format();
                $scope.product.mp_1_audited_by = currentUser.user_name;
            });
        };

        $scope.update_mp_uk_audit_sucess = 0;

        $scope.update_mp_uk_audit = function(currentUser) {

            var payload = {
                mp_uk_audited_changed:1,
                product_id:$scope.product_id
            };

            datacontext.update_product(payload).then(function() {
                $scope.update_mp_uk_audit_sucess = 1;
                // reload product query
                //fake updated
                $scope.product.mp_uk_audited_on = moment().format();
                $scope.product.mp_uk_audited_by = currentUser.user_name;
            });
        };

        function getProductStatus() {
            return datacontext.get_product_status(vm.product_id).then(function(httpResult) {
                vm.product_status = httpResult.data.data;
            });
        }

        function get_price_rules() {
            return datacontext.get_price_rules().then(function(httpResult) {
                $scope.price_rules = httpResult.data.data;
            });
        }

        function get_aws_variation_themes() {
            return datacontext.get_aws_variation_themes().then(function(httpResult) {
                vm.aws_variation_themes = httpResult.data.data;
            });
        }

        function get_product_pod_dimensions() {
            return datacontext.get_product_pod_dimensions().then(function (httpResult) {
                vm.pod_dimensions = httpResult.data.data;

            });
        }

        function getProductCategories() {
            return datacontext.get_product_categories().then(function (httpResult) {
                vm.product_categories = httpResult.data;
            });
        }

        function getProductOrientations() {
            return datacontext.get_product_orientation().then(function (httpResult) {
                vm.product_orientation = httpResult.data;
            });
        }

        function getManufacturers() {
           if(angular.isDefined($scope.manufadded)){
            $scope.product_man ={use_cache:0};
             return datacontext.get_manufacturers_no_cache($scope.product_man).then(function (httpResult) {
                 vm.manufacturers = httpResult.data;
             });
           }else{
             return datacontext.get_manufacturers().then(function (httpResult) {
                 vm.manufacturers = httpResult.data;
             });
           }

        }

        function get_product_source_list() {
            return datacontext.get_product_source_list().then(function (httpResult) {

                vm.product_source = httpResult.data;
            });
        }

        function get_license_region_list() {
            return datacontext.get_license_region_list().then(function (httpResult) {
                vm.license_regions = httpResult.data;
            });
        }
        function get_content_themes_list() {
            return datacontext.get_content_themes_list().then(function (httpResult) {
                vm.content_themes = httpResult.data;
            });
        }

        function get_shipping_regions() {
            return datacontext.get_shipping_regions().then(function (httpResult) {
                vm.shipping_regions = httpResult.data.data;
            });
        }

        function getProductSets() {
            var payload = {product_id:$scope.product_id};
            return datacontext.getProductSets(payload).then(function (httpResult) {
                vm.productSets = httpResult.data.data;
                vm.productSetsLength = httpResult.data.LENGTH;
            });
        }
        function get_stores() {
            return datacontext.get_stores().then(function(httpResult) {
                vm.stores = httpResult.data.data;
            });
        }
        function get_warehouses() {
            return datacontext.get_warehouses().then(function(httpResult) {
                $scope.warehouses = httpResult.data.data;
            });
        }

        $scope.reQueueProductImage = function() {

            $scope.requeueStart = 1;

            datacontext.reQueueProductImage(vm.product_id).success(function(httpResult) {

                $scope.requeueStart = 0;
                $scope.requeueSuccess = 1;

            });
        };

        // go next product no asin
        $scope.get_next_product_no_sku = function() {
            datacontext.get_next_product_no_sku().success(function(response) {
                $location.url('products/' + response);
            });
        };

        // go next product not fit to sell
        $scope.get_next_product_not_fit_to_sell = function() {
            datacontext.get_next_product_not_fit_to_sell().success(function(response) {
                $location.url('products/' + response);
            });
        };

        // Re-Process Framed Images
        $scope.reProcess_framed_images = function(master_product_id,categoryId,frame_color) {
            log_success("Re-Processing Image");
            if(categoryId === 33){
              datacontext.reProcess_framed_images(master_product_id,0,frame_color).success(function(response) {
                  log_success("Image Re-Processed Successfully !!!");
                  if(response.length > 0){
                    log_success(response);
                  }
              });
            }else if(categoryId === 55){
              datacontext.reProcess_framed_images(master_product_id,0,frame_color).success(function(response) {
                  log_success("Image Re-Processed Successfully !!!");
                  if(response.length > 0){
                    log_success(response);
                  }
              });
            }else if(categoryId === 46){
              datacontext.reProcess_framed_images(master_product_id,1,frame_color).success(function(response) {
                if(response.length > 0){
                  log_success(response);
                }
                  log_success("Image Re-Processed Successfully !!!");
              });
            }else{
              datacontext.reProcess_2436_images(master_product_id).success(function(response) {
                if(response.length > 0){
                  log_success(response);
                }
                log_success("Image Re-Processed Successfully !!!");
              });
            }

        };

    // tm review
    $scope.tm_review = function() {
        $scope.product_update = 1;
        $scope.alert_msg_keywords = 0;
        $scope.alert_msg_msrp = 0;

        datacontext.tm_review($scope.product).then(function(httpResult) {
          console.log(httpResult.data.data);
          $scope.tm_error_msg = httpResult.data.data;
        });
    };

        $scope.upd_orientation_check = 0;
        //$scope.product.upd_orientation = 0;

        $scope.is_orientation_checked = function(orientation) {
            console.log(orientation);
            if ( orientation == 1 || orientation === true) {
                $scope.upd_orientation_check = 1; 
            } else{
                $scope.upd_orientation_check = 0;
            }
            //$scope.product.upd_orientation = $scope.upd_orientation_check;
            console.log($scope.upd_orientation_check);
        }

        // Updates Products
        $scope.update_product = function() {
            if ($scope.product.is_active_override == 1 && $scope.product.description_status_id > 1 &&
                (!$scope.product.product_name || $scope.product.product_name.length < 30)) {
 
                log_error("Product Name must be at least 30 characters before Description Status can be set above 1.");
                return;
            }
            $scope.product_update = 1;
            $scope.product.from_product_update = 1;
            $scope.alert_msg_keywords = 0;
            $scope.alert_msg_msrp = 0;

            $scope.alert_msg_overide = 0;

            console.log('1277');

            datacontext.update_product($scope.product).then(function() {
                // check keywords
                if ($scope.product.keyword_group_1.length === 0){
                    $scope.alert_msg_keywords = 1;
                }
                // check msrp
                if ($scope.product.msrp.length === 0 || $scope.product.msrp === 0){
                    $scope.alert_msg_msrp = 1;
                }
                // get updated audit
                $routeParams.todesc = 1;
                var toURl = '/product/'+$routeParams.pid;
                $location.path(toURl).search({todesc: '1'});
                //$location.path('/product/').search({todesc: '1'});
                get_products();
                $scope.$broadcast('refreshAuditLog', 'refresh');
                // scroll to top
                $scope.alert_msg_overide = 0;
                $location.hash('top');
                $anchorScroll();
            });
        };

        // swap dimensions
        $scope.swap_dimensions = function() {
            var height = $scope.product.height;
            var width = $scope.product.width;

                $scope.product.height = width;
                $scope.product.width = height;
        };

        $scope.refresh_on_hand = function() {
            var product_id = $scope.product.product_id;
            var master_inv_pid = $scope.product.master_inv_pid;
            //console.log($scope.product);
            if(master_inv_pid > 0){
              datacontext.refresh_on_hand_mpid(product_id,master_inv_pid).success(function(httpResult) {
                  log("Refreshed");
                  get_products();

              });
            }else{
              datacontext.refresh_on_hand(product_id).success(function(httpResult) {
                  log("Refreshed");
                  get_products();

              });
            }



        };
        // swap dimensions
        $scope.paste_ebay_title = function() {
            $scope.product.ebay_prefix = $scope.product.product_title;
        };

        $scope.paste_ebay_title_suffix = function() {
            $scope.product.ebay_suffix = $scope.product.product_title;
        };

        $scope.gotoStoreProducts = function() {
            // set the location.hash to the id of
            // the element you wish to scroll to.
            $location.hash('store-products');

            // call $anchorScroll()
            $anchorScroll();
        };

        $scope.gotoVendorProducts = function() {
            // set the location.hash to the id of
            // the element you wish to scroll to.
            $location.hash('vendor-products');

            // call $anchorScroll()
            $anchorScroll();
        };
        $scope.gotoProductLocation = function() {
            // set the location.hash to the id of
            // the element you wish to scroll to.
            $location.hash('location-products');

            // call $anchorScroll()
            $anchorScroll();
        };

        $scope.gotoProductAudit = function() {
            // set the location.hash to the id of
            // the element you wish to scroll to.
            $location.hash('audit-log');

            // call $anchorScroll()
            $anchorScroll();
        };

        $scope.gotoProductSales = function() {
            // set the location.hash to the id of
            // the element you wish to scroll to.
            $location.hash('productSales');

            // call $anchorScroll()
            $anchorScroll();
        };

        $scope.get_getty_keywords = function (product_id) {

            $scope.payload = {
                product_id: product_id
            };

            var modalInstance = $modal.open({
                templateUrl: '/app/products/partials/getty_keywords.html',
                controller: 'gettyKeywordCtrl',
                resolve: {
                    payload: function () {
                        return $scope.payload;
                    }
                }
            }).result.then(function(result){
                //activate();
            });

            $scope.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

        $scope.clone_kws = function(pid) {

        	var payload = {
                "manufacturer_id":$scope.product.manufacturer_id,
                "category_id": $scope.product.category_id,
                "product_source_id": $scope.product.product_source_id,
                "pid":pid

            };

        	datacontext.get_clone_kws(payload).then(function(httpResult) {
        		 vm.product_description = httpResult.data.data;
        		 $scope.product.keyword_group_1 = vm.product_description[0].keyword_group_1;
        		 //$scope.product.min_price = vm.product_description[0].min_price;
        		 //$scope.product.max_price = vm.product_description[0].max_price;
        		 //$scope.product.price = vm.product_description[0].price;
        		 //$scope.product.msrp = vm.product_description[0].msrp;
        		 //$scope.product.oversell = vm.product_description[0].oversell;

        		 $scope.clone_notes = 'Information cloned from item <a href="#/product/' + vm.product_description[0].product_id +'" target="_blank">' + vm.product_description[0].product_id + '</a>. please review below info carefully<br><br>';
        		 $scope.product.clone_notes = 'test';
        		 $('#keyword_group_1').addClass('highlight_selected_clone');
        		 // $('#min_price').addClass('highlight_selected_clone');
        		 // $('#max_price').addClass('highlight_selected_clone');
        		 // $('#price').addClass('highlight_selected_clone');
        		 // $('#msrp').addClass('highlight_selected_clone');
        		 // $('#oversell').addClass('highlight_selected_clone');

        	 });
        };

        $scope.clone_akws = function(pid) {
          //console.log("clonepid:"+pid);
        	var payload = {
                "manufacturer_id":$scope.product.manufacturer_id,
                "category_id": $scope.product.category_id,
                "product_source_id": $scope.product.product_source_id,
                "pid":pid

            };
          if(pid > 0){
            $scope.clone_product_id = pid;
            $scope.refreshProductAttributesCtrl();
            $scope.clone_anotes = 'Information cloned from item <a href="#/product/' + pid +'" target="_blank">' + pid + '</a>. please review below info carefully<br><br>';
          }else{
            datacontext.get_clone_akws(payload).then(function(httpResult) {

            $scope.productAttributes = httpResult.data.data[0];
            if(angular.isDefined(httpResult.data.data[0])){
              //console.log($scope.productAttributes);
              //console.log($scope.productAttributes.product_id);
              $scope.clone_product_id = $scope.productAttributes.product_id;
              $scope.$broadcast('refreshProductAttributesCtrl', 'refresh');
              //$scope.refreshProductAttributesCtrl();
              //$scope.productAttributes = httpResult.data.data[0];
              //vm.productAttributes = httpResult.data.data[0];
          		$scope.clone_anotes = 'Information cloned from item <a href="#/product/' + $scope.productAttributes.product_id +'" target="_blank">' + $scope.productAttributes.product_id + '</a>. please review below info carefully<br>';


            }else{
              $scope.clone_anotes = 'No details, try with particular PID';
            }

          	 });
          }

        };

    }
})();

(function() {
    'use strict';
    var controllerId = 'printPidModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance','pid_print', 'user_name', printPidModalCtrl]);

    function printPidModalCtrl(common, datacontext, $scope, $modalInstance, pid_print, user_name) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');
        var vm = this;

        $scope.pid_print = pid_print;
        console.log($scope.pid_print);
        $scope.user_name = user_name;

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }
})();

(function(){
    'use strict';
    var controllerId = 'printPosterModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance','print_poster', 'user_name', printPosterModalCtrl]);

    function printPosterModalCtrl(common, datacontext, $scope, $modalInstance, print_poster, user_name){
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId, 'success');
        var log_error = getLogFn(controllerId,'error');
        var vm = this;

        $scope.product_id = print_poster.product_id;
        $scope.product_title = print_poster.product_title;
        $scope.width = print_poster.width;
        $scope.height = print_poster.height;
        $scope.pod_dimension_id = print_poster.pod_dimension_id;
        $scope.master_product_id = print_poster.master_product_id;
        $scope.category_id = print_poster.category_id;
        $scope.layout = print_poster.layout;
        $scope.layout_name = print_poster.layout_name;
        $scope.qty_to_print = print_poster.qty_to_print;
        $scope.user_orientation_id = print_poster.user_orientation_id;

        $scope.print_poster = print_poster;
        console.log($scope.print_poster);
        $scope.user_name = user_name;

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

        $scope.submit_print_poster = function(product_id, width, height, printer, qty_to_print, pod_dimension_id, master_product_id, category_id, layout, layout_name, user_orientation_id){
            console.log('product_id: ' + product_id);
            console.log('width: ' + width);
            console.log('height: ' + height);
            console.log('printer '+ printer);
            console.log('qty_to_print '+ qty_to_print);
            console.log('pod_dimension_id '+ pod_dimension_id);
            console.log('master_product_id '+ master_product_id);
            console.log('category_id '+ category_id);
            console.log('layout '+ layout);
            console.log('layout_name '+ layout_name);
            console.log('user_orientation_id '+ user_orientation_id);

            if(printer == 20){
                $scope.printer_name = 'EPSON P20';
            }else if(printer == 70){
                $scope.printer_name = 'Epson 777-1';
            }else if(printer == 71){
                $scope.printer_name = 'Epson 777-2';
            }else if(printer == 72){
                $scope.printer_name = 'Epson 777-3';
            }else if(printer == 82){
                $scope.printer_name = 'HP 8200';
            }else if(printer == 99){
                $scope.printer_name = 'Xerox';
            }

            if(master_product_id != 0){
                master_product_id = master_product_id;
            }

            if(!angular.isDefined(layout) || printer == 0){
                log_error("Please select HP Printer");
                $scope.error_message = "Please select Printer";
            }else if(!angular.isDefined(layout)){
                log_error("Please selecct Layout");
            }else{
                if(pod_dimension_id == 2 || pod_dimension_id == 3){
                    if(master_product_id != 0){
                        datacontext.print_poster_xerox_master_pid(master_product_id, product_id, printer, width, height, category_id, pod_dimension_id, qty_to_print, layout, layout_name, user_orientation_id).success(function(response){
                            //log_success("Image pushed to printer" +$scope.printer_name);

                            $scope.success_message = "Item sent for printing.";
                            log_success("Details sent through email");
                            $modalInstance.close();
                        });
                    }else{
                        datacontext.print_poster_xerox_pid(product_id, printer, width, height, category_id, pod_dimension_id, qty_to_print, layout, layout_name, user_orientation_id).success(function(response){
                            //log_success("Image pushed to printer" +$scope.printer_name);
                            $scope.success_message = "Item sent for printing.";
                            log_success("Details sent through email");
                            $modalInstance.close();
                        });
                    }
                }else{
                    if(master_product_id != 0){
                        datacontext.print_poster_master_pid(master_product_id, product_id, printer, width, height, category_id, pod_dimension_id, qty_to_print, layout, layout_name, user_orientation_id).success(function(response){
                            //log_success("Image pushed to printer" +$scope.printer_name);
                            $scope.success_message = "Item sent for Xerox.";
                            log_success("Details sent through email");
                            $modalInstance.close();
                        });
                    }else{
                        datacontext.print_poster_pid(product_id, printer, width, height, category_id, pod_dimension_id, qty_to_print, layout, layout_name, user_orientation_id).success(function(response){
                            //log_success("Image pushed to printer" +$scope.printer_name);
                            $scope.success_message = "Item sent for Xerox.";
                            log_success("Details sent through email");
                            $modalInstance.close();
                        });
                    }
                }
            }


        }
    }
})();

(function() {
    'use strict';
    var controllerId = 'gettyKeywordCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance','payload', gettyKeywordCtrl]);

    function gettyKeywordCtrl(common, datacontext, $scope, $modalInstance, payload) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        $scope.list = "";
        datacontext.get_getty_image_products(payload).then(function(httpResult){
            $scope.list = httpResult.data.data[0].keywords;
        });

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'productUpdateCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$routeParams', productUpdateCtrl]);

    function productUpdateCtrl(common, datacontext, $scope, $routeParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.product = [];
        vm.location_products = [];

        vm.product_id = $routeParams.pid;
        $scope.product_id = $routeParams.pid;
        vm.title = 'Product Detail View';

        activate();

        function activate() {
            var promises = [get_product_status()];
            common.activateController(promises, controllerId)
                .then(function() {
                    // log('Activated Product Detail View');
                });
        }

        function get_product_status() {
            return datacontext.get_product_status(vm.product_id).then(function(httpResult) {
                vm.product_status = httpResult.data.data;
            });
        }



        // update Product
        $scope.update_product = function () {
            console.log('1553');
            datacontext.update_product(vm.poi).then(function (httpResult) {
                log('product updated');
            });
        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'productTeaserCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', productTeaserCtrl]);

    function productTeaserCtrl(common, datacontext, $scope) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        vm.product_update = 0;

        activate();

        function activate() {
            var promises = [get_product_detail(), getProductCategories()];
            common.activateController(promises, controllerId)
                .then(function() {

                });
        }

        function getProductCategories() {
            return datacontext.get_product_categories().then(function (httpResult) {
                vm.product_categories = httpResult.data;
            });
        }

        function get_product_detail() {
            return datacontext.get_product_detail($scope.product_id).then(function(httpResult) {
                vm.product = httpResult.data.data[0];
            });
        }

        // Updates Products
        $scope.update_product = function(idx) {

            vm.product_update = 1;
            console.log('1600');

            // Set Product scope
            var product =
            {
                product_id:idx.product_id,
                category_id:idx.category_id,
                width:idx.width,
                height:idx.height,
                depth:idx.depth,
            };

            datacontext.update_product(product).then(function() {

                get_product_detail();

                vm.product_update= 1;
            });
        };


    }
})();

(function() {
    'use strict';
    var controllerId = 'productCreateModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance','product_create', productCreateModalCtrl]);

    function productCreateModalCtrl(common, datacontext, $scope, $modalInstance, product_create) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        // Pushes input to scope
        $scope.po_id = product_create.po_id;
        $scope.submitted = 0;
        $scope.message_text = '';

        datacontext.get_manufacturers().then(function (httpResult) {
            $scope.manufacturers = httpResult.data;
        });


        datacontext.get_product_categories().then(function (httpResult) {
            $scope.product_categories = httpResult.data;
        });
        //console.log("rec");
      //  console.log(product_create);
        // Set Product Defaults
        $scope.product =
            {
                product_name:"",
                manufacturer_id:product_create.vendor_id,
                category_id:13,
                width:"",
                height:"",
                msrp:0,
                weight:0
            };
      //  console.log($scope.product);
        // Updates Products
        $scope.create_product = function(isValid) {

            if (isValid) {
                datacontext.create_product($scope.product).then(function(response) {
                    $scope.product.product_id = response.data.data;

                    $scope.isCreated = true;
                    // Redirect
                    $modalInstance.close($scope.product);
                });
            } else{
                $scope.message_text = 'Missing Information';
            }
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'productimgUploadCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$http', '$location', productimgUploadCtrl]);

    function productimgUploadCtrl(common, datacontext, $scope, $http, $location) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var vm = this;

        activate();

        function activate() {
            var promises = [];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Task List View');
                });
        }
    }
})();

(function () {
    'use strict';
    var controllerId = 'endlessScrollCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$http', '$timeout', '$q', endlessScrollCtrl]);

    function endlessScrollCtrl(common, datacontext, $scope, $http, $timeout, $q) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);


        // ui.grid, ui.grid.infiniteScroll

        var vm = this;

        activate();

        function activate() {
            var promises = [];
            common.activateController(promises, controllerId)
                .then(function() {

                });
        }

        $scope.gridOptions = {
            infiniteScrollRowsFromEnd: 40,
            infiniteScrollUp: true,
            infiniteScrollDown: true,
            rowHeight: 100,
            columnDefs: [
                { field:'image', width: 100, cellTemplate:"<img width=\"100px\" data-ng-src=\"{{grid.getCellValue(row, col)}}\" lazy-src>"},
                { field:'sku' },
                { field:'product_title', displayName: 'product title', width: 150},
                { field:'width' },
                { field:'height' },
                { field:'on hand' },
                { field:'price' },
                { field:'avg cogs' },
                { field:'10 day sales' }
            ],
            data: 'data',
            onRegisterApi: function(gridApi){
                gridApi.infiniteScroll.on.needLoadMoreData($scope, $scope.getDataDown);
                gridApi.infiniteScroll.on.needLoadMoreDataTop($scope, $scope.getDataUp);
                $scope.gridApi = gridApi;
            }
        };

        $scope.data = [];
        $scope.firstPage = 2;
        $scope.lastPage = 2;

        $scope.getFirstData = function() {
            var promise = $q.defer();

            var query = {
                    limit: 10,
                    page: 1
            };

            /*
            datacontext.get_products(query).then(function(httpResult) {
                $scope.data = httpResult.data.data;
               // $scope.count = data.total;

                console.log(httpResult);
            });
            */


            $http.get('/tasks/products/10000_complex.json?id=10')
                .success(function(data) {
                    var newData = $scope.getPage(data, $scope.lastPage);
                    $scope.data = $scope.data.concat(newData);
                    promise.resolve();
                });
            return promise.promise;

        };

        $scope.getDataDown = function() {
            var promise = $q.defer();
            $http.get('/tasks/products/10000_complex.json?id=101')
                .success(function(data) {
                    $scope.lastPage++;
                    var newData = $scope.getPage(data, $scope.lastPage);
                    $scope.gridApi.infiniteScroll.saveScrollPercentage();
                    $scope.data = $scope.data.concat(newData);
                    $scope.gridApi.infiniteScroll.dataLoaded($scope.firstPage > 0, $scope.lastPage < 4).then(function() {$scope.checkDataLength('up');}).then(function() {
                        promise.resolve();
                    });
                })
                .error(function(error) {
                    $scope.gridApi.infiniteScroll.dataLoaded();
                    promise.reject();
                });
            return promise.promise;
        };

        $scope.getDataUp = function() {
            var promise = $q.defer();
            $http.get('/tasks/products/10000_complex.json?id=2')
                .success(function(data) {
                    $scope.firstPage--;
                    var newData = $scope.getPage(data, $scope.firstPage);
                    $scope.gridApi.infiniteScroll.saveScrollPercentage();
                    $scope.data = newData.concat($scope.data);
                    $scope.gridApi.infiniteScroll.dataLoaded($scope.firstPage > 0, $scope.lastPage < 4).then(function() {$scope.checkDataLength('down');}).then(function() {
                        promise.resolve();
                    });
                })
                .error(function(error) {
                    $scope.gridApi.infiniteScroll.dataLoaded();
                    promise.reject();
                });
            return promise.promise;
        };


        $scope.getPage = function(data, page) {
            var res = [];
            for (var i = (page * 100); i < (page + 1) * 100 && i < data.length; ++i) {
                res.push(data[i]);
            }
            return res;
        };

        $scope.checkDataLength = function( discardDirection) {
            // work out whether we need to discard a page, if so discard from the direction passed in
            if( $scope.lastPage - $scope.firstPage > 3 ){
                // we want to remove a page
                $scope.gridApi.infiniteScroll.saveScrollPercentage();

                if( discardDirection === 'up' ){
                    $scope.data = $scope.data.slice(100);
                    $scope.firstPage++;
                    $timeout(function() {
                        // wait for grid to ingest data changes
                        $scope.gridApi.infiniteScroll.dataRemovedTop($scope.firstPage > 0, $scope.lastPage < 4);
                    });
                } else {
                    $scope.data = $scope.data.slice(0, 400);
                    $scope.lastPage--;
                    $timeout(function() {
                        // wait for grid to ingest data changes
                        $scope.gridApi.infiniteScroll.dataRemovedBottom($scope.firstPage > 0, $scope.lastPage < 4);
                    });
                }
            }
        };

        $scope.reset = function() {
            $scope.firstPage = 2;
            $scope.lastPage = 2;

            // turn off the infinite scroll handling up and down - hopefully this won't be needed after @swalters scrolling changes
            $scope.gridApi.infiniteScroll.setScrollDirections( false, false );
            $scope.data = [];

            $scope.getFirstData().then(function(){
                $timeout(function() {
                    // timeout needed to allow digest cycle to complete,and grid to finish ingesting the data
                    $scope.gridApi.infiniteScroll.resetScroll( $scope.firstPage > 0, $scope.lastPage < 4 );
                });
            });
        };

        $scope.getFirstData().then(function(){
            $timeout(function() {
                // timeout needed to allow digest cycle to complete,and grid to finish ingesting the data
                // you need to call resetData once you've loaded your data if you want to enable scroll up,
                // it adjusts the scroll position down one pixel so that we can generate scroll up events
                $scope.gridApi.infiniteScroll.resetScroll( $scope.firstPage > 0, $scope.lastPage < 4 );
            });
        });


    }
})();

(function() {
    'use strict';
    var controllerId = 'productDashboardCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', productDashboardCtrl]);

    function productDashboardCtrl(common, datacontext, $scope) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var vm = this;

        vm.title = 'Product Dashboard Detail View';
        var filter = {};

        activate();

        function activate() {
            var promises = [
                get_counts()];
            common.activateController(promises, controllerId)
                .then(function() {
                    // log('Activated Product Dashboard View');
                });
        }

        function get_counts() {

            $scope.imageJson = {
                image_status_id:1,
                in_stock:1,
                queryType:"count"
            };
            $scope.imageUrl = $.param($scope.imageJson);

            datacontext.get_products($scope.imageJson).then(function(httpResult) {
                $scope.imageCount = httpResult.data.total;
            });

            $scope.reImageJson = {
                image_status_id:2,
                in_stock:1,
                queryType:"count"
            };

            $scope.reImageUrl = $.param($scope.reImageJson);

            datacontext.get_products($scope.reImageJson).then(function(httpResult) {
                $scope.reImageCount = httpResult.data.total;
            });

            // description needed
            $scope.descJson = {
                image_status_id:3,
                description_status_id:"1,5",
                in_stock:1,
                queryType:"count"
            };

            $scope.descUrl = $.param($scope.descJson);
            datacontext.get_products($scope.descJson).then(function(httpResult) {
                $scope.descCount = httpResult.data.total;
            });

            // asin desc needed
            $scope.asinJson = {
                image_status_id:1,
                asin_iscomplete:0,
                in_stock:1,
                queryType:"count"
            };

            $scope.asinUrl = $.param($scope.asinJson);
            datacontext.get_products($scope.asinJson).then(function(httpResult) {
                $scope.asinCount = httpResult.data.total;
            });

            // has orphan
            $scope.orphanJson = {
                has_orphan:1,
                in_stock:1,
                description_status_id:3,
                is_active_override:1,
                queryType:"count"
            };

            $scope.orphanUrl = $.param($scope.orphanJson);
            datacontext.get_products($scope.orphanJson).then(function(httpResult) {
                $scope.orphanCount = httpResult.data.total;
            });

            // GCID Feed
            $scope.gcidActiveJson = {
                store_id:9,
                warehouse_id:4,
                queryType:"count"
            };

            $scope.syndS1ActiveUrl = $.param($scope.gcidActiveJson);
            datacontext.get_gcid_store_products($scope.gcidActiveJson).then(function(httpResult) {
                $scope.gcidActiveCount = httpResult.data.total;
            });

            // INVENTORY PUSH TO AMAZON
            $scope.invToPushJson = {
                store_id:9,
                warehouse_id:4,
                queryType:"count"
            };

            $scope.syndS1ActiveUrl = $.param($scope.invToPushJson);
            datacontext.get_inv_to_push_store_products($scope.invToPushJson).then(function(httpResult) {
                $scope.invToPushCount = httpResult.data.total;
            });

            // synd PA-AMZ error
            $scope.syndS1PendingJson = {
                in_stock:1,
                is_active_override:1,
                store_product_status_id:3,
                synd_sync_timeout:1,
                store_id:1,
                queryType:"count"};

            $scope.syndS1PendingUrl = $.param($scope.syndS1PendingJson);

            datacontext.get_spid_synd_sync_pending_pa_amz($scope.syndS1PendingJson).then(function(httpResult) {
                console.log(httpResult.data);
                $scope.syndS1PendingCount = httpResult.data.total;
            });

            // synd PA-AMZ error
            $scope.syndS1ActiveJson = {
                in_stock:1,
                is_active_override:1,
                store_product_status_id: "1",
                synd_sync_timeout:1,
                store_id:1,
                queryType:"count"};

            $scope.syndS1ActiveUrl = $.param($scope.syndS1ActiveJson);
            datacontext.get_spid_synd_sync_active_pa_amz($scope.syndS1ActiveJson).then(function(httpResult) {
                $scope.syndS1ActiveCount = httpResult.data.total;
            });

            // synd RH-AMZ error
            $scope.syndS2PendingJson = {
                in_stock:1,
                is_active_override:1,
                store_product_status_id: "3",
                synd_sync_timeout:1,
                store_id:9,
                queryType:"count"};

            $scope.syndS2PendingUrl = $.param($scope.syndS2PendingJson);
            datacontext.get_spid_synd_sync_pending_pf_amz($scope.syndS2PendingJson).then(function(httpResult) {
                $scope.syndS2PendingCount = httpResult.data.total;
            });

            // synd PH-AMZ error
            $scope.syndS2ActiveJson = {
                in_stock:1,
                is_active_override:1,
                store_product_status_id: "1",
                synd_sync_timeout:1,
                store_id:9,
                warehouse_id:4,
                queryType:"count"};

            $scope.syndS2ActiveUrl = $.param($scope.syndS2ActiveJson);
            datacontext.get_spid_synd_sync_active_pf_amz($scope.syndS2ActiveJson).then(function(httpResult) {
                $scope.syndS2ActiveCount = httpResult.data.total;
            });

            // synd PA-Ebay error
            $scope.syndS4PendingJson = {
                in_stock:1,
                is_active_override:1,
                store_product_status_id: "3",
                synd_sync_timeout:1,
                store_id:4,
                queryType:"count"};

            $scope.syndS4PendingUrl = $.param($scope.syndS4PendingJson);
            datacontext.get_store_products($scope.syndS4PendingJson).then(function(httpResult) {
                $scope.syndS4PendingCount = httpResult.data.total;
            });

            $scope.syndS4ActiveJson = {
                in_stock:1,
                is_active_override:1,
                store_product_status_id: "1",
                synd_sync_timeout:1,
                store_id:4,
                queryType:"count"};

            $scope.syndS4ActiveUrl = $.param($scope.syndS4ActiveJson);
            datacontext.get_store_products($scope.syndS4ActiveJson).then(function(httpResult) {
                $scope.syndS4ActiveCount = httpResult.data.total;
            });

            // synd RH-BigCom error
            $scope.syndS5PendingJson = {
                in_stock:1,
                is_active_override:1,
                store_product_status_id: "3",
                synd_sync_timeout:1,
                store_id:5,
                queryType:"count"};

            $scope.syndS5PendingUrl = $.param($scope.syndS5PendingJson);
            datacontext.get_store_products($scope.syndS5PendingJson).then(function(httpResult) {
                $scope.syndS5PendingCount = httpResult.data.total;
            });

            $scope.syndS5ActiveJson = {
                in_stock:1,
                is_active_override:1,
                store_product_status_id: "1",
                synd_sync_timeout:1,
                store_id:5,
                queryType:"count"};

            $scope.syndS5ActiveUrl = $.param($scope.syndS5ActiveJson);

            datacontext.get_store_products($scope.syndS5ActiveJson).then(function(httpResult) {
                $scope.syndS5ActiveCount = httpResult.data.total;
            });

            $scope.syndInvError = {
                url:'',
                json : {
                    in_stock:1,
                    is_active_override:1,
                    store_product_status_id:1,
                    synd_inv_error:1,
                    queryType:"count"
                },
                count:0
            };

            $scope.syndInvError.url = $.param($scope.syndInvError.json);
            datacontext.get_store_products($scope.syndInvError.json).then(function(httpResult) {
                $scope.syndInvError.count = httpResult.data.total;
            });

            $scope.synd_sync_fail = {
                url:'',
                json : {
                    in_stock:1,
                    is_active_override:1,
                    store_product_status_id:1,
                    synd_sync_fail:1,
                    queryType:"count"
                },
                count:0
            };

            $scope.synd_sync_fail.url = $.param($scope.synd_sync_fail.json);
            datacontext.get_spid_synd_sync_fail($scope.synd_sync_fail.json).then(function(httpResult) {
                $scope.synd_sync_fail.count = httpResult.data.total;
            });

            // amazon OVERSELLING // amazon OVERSELLING 2 // amazon UNDERSELLING
            datacontext.get_amz_overselling().then(function(httpResult) {
                $scope.amz_over_sell_count = httpResult.data.total;
                $scope.amz_over_sell_count2 = httpResult.data.total2;
                $scope.amz_under_sell_count = httpResult.data.total3;
            });

            // eBay OVERSELLING // eBay UNDERSELLING
            datacontext.get_ebay_overselling().then(function(httpResult) {
                $scope.ebay_over_sell_count = httpResult.data.total;
                $scope.ebay_under_sell_count = httpResult.data.total2;
            });

            //Inactive Being Sold
            datacontext.get_inactive_being_sold().then(function(httpResult) {
                $scope.inactive_being_sold_count = httpResult.data.total;
            });

            //Product Title Too Long
            datacontext.get_products_title_too_long().then(function(httpResult) {
                $scope.products_title_too_long = httpResult.data.total;
            });

            //Pending P/C
            datacontext.get_parent_relationship_pending_count().then(function(httpResult) {
                $scope.parent_pending = httpResult.data.TOTAL;
                $scope.relationship_pending = httpResult.data.TOTAL_1;
            });
        }
    }
})();

/*(function () {
    'use strict';
    var controllerId = 'productRelationshipsCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$modal','$scope', productRelationshipsCtrl]);

    function productRelationshipsCtrl(common, datacontext, $modal, $scope) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        vm.query = {
            search: '',
            order_by: 'is_forSale',
            order_dir: 'desc'
        };

        // activated via tab
        // activate();

        $scope.$on('refreshProductRelationshipsCtrl', function (event, data) {
            console.log(data);
            activate();
        });

        function activate() {
            var promises = [
                getProductRelationshipTypes(),
                getProductRelationships()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Task List View');
                });
        }

        function getProductRelationshipTypes() {
            return datacontext.getProductRelationshipTypes().then(function (httpResult) {
                vm.productRelationshipTypes = httpResult.data.data;
            });
        }

        function getProductRelationships() {
            var payload = {product_id:$scope.product_id};
            return datacontext.getProductRelationships(payload).then(function (httpResult) {
                vm.selectedProductRelationships = httpResult.data.data;
                //console.log(vm.selectedProductRelationships);
            });
        }

        $scope.$watch('productSearch', function (tmpStr) {
            if (!tmpStr || tmpStr.length == 0) {
                return 0;
            }
            setTimeout(function() {
                // if searchStr is still the same..
                // go ahead and retrieve the data
                if (tmpStr === $scope.productSearch) {
                    vm.query.search = $scope.productSearch;
                    return datacontext.get_products(vm.query).then(function (httpResult) {
                        vm.products = httpResult.data.data;
                    });
                }
            }, 500);
        });


        $scope.create_phantom = function (data) {

            $scope.payload = {
                data: data,
                step: 1
            };

            var modalInstance = $modal.open({
                templateUrl: '/app/products/partials/amz_phantom_create_modal.html',
                controller: 'createPhantomModalCtrl',
                resolve: {
                    payload: function () {
                        return $scope.payload;
                    }
                }
            }).result.then(function(result){
                activate();
            });

            $scope.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

        $scope.create_product_relationship = function (payload) {
            return datacontext.create_product_relationship(payload).then(function () {
                getProductRelationships();
            });
        };

        $scope.deleteProductRelationship = function (payload) {
            return datacontext.deleteProductRelationship(payload).then(function () {
                getProductRelationships();
            });
        };
    }
})();*/

(function () {
    'use strict';
    var controllerId = 'productAttributesCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$modal', '$cookies', '$scope', productAttributesCtrl]);

    function productAttributesCtrl(common, datacontext, $modal, $cookies, $scope) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        //console.log("inside");
        vm.query = {
            search: '',
            order_by: 'is_forSale',
            order_dir: 'desc'
        };
        if( angular.isDefined($cookies.get('user_role_id')) ) {
          vm.user_role_id = $cookies.get('user_role_id');
          console.log("vm.user_role_id:"+vm.user_role_id);
        }
        $scope.attr_update = 0;
        $scope.attr_update_done = 0;
        $scope.root_title_check = 0;
        $scope.upd_product_source_check = 0;
        // activated via tab
        // activate();
        vm.master_product_id = $scope.master_product_id;
        $scope.$on('refreshProductAttributesCtrl', function (event, data) {
          activate();
        });
        //console.log($scope);

        function activate() {
            var promises = [
                getProductAttributes(),
                getAmazonSubjects()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Task List View');
                });
        }

        $scope.is_checked = function(title) {
            console.log(title);
            if ( title == 1 || title === true) {
                $scope.root_title_check = 1;
            } else{
                $scope.root_title_check = 0;
            }
            console.log($scope.root_title_check);
        }

        $scope.is_ps_checked = function(upd_product_source) {
            console.log(upd_product_source);
            if ( upd_product_source == 1 || upd_product_source === true) {
                $scope.upd_product_source_check = 1;
            } else{
                $scope.upd_product_source_check = 0;
            }
            console.log($scope.upd_product_source_check);
        }

        function getProductAttributes() {
          if(angular.isDefined($scope.clone_product_id)){
            var payload = {product_id:$scope.clone_product_id};
          }else{
            var payload = {product_id:$scope.product_id};
          }

            return datacontext.getProductAttributes(payload).then(function (httpResult) {

                console.log("Testing-YK");
                console.log(angular.isDefined($scope.clone_product_id));

              if(angular.isDefined($scope.clone_product_id)){
                console.log(httpResult.data.data[0]);
                $scope.productAttributes.keyword_group_1 = httpResult.data.data[0].keyword_group_1;
                $scope.productAttributes.custom_bullet_1 = httpResult.data.data[0].custom_bullet_1;
                $scope.productAttributes.custom_bullet_2 = httpResult.data.data[0].custom_bullet_2;
                $scope.productAttributes.custom_bullet_3 = httpResult.data.data[0].custom_bullet_3;
                $scope.productAttributes.custom_bullet_4 = httpResult.data.data[0].custom_bullet_4;
                $scope.productAttributes.custom_bullet_5 = httpResult.data.data[0].custom_bullet_5;
              }else{
                $scope.productAttributes = httpResult.data.data[0];
                $scope.productAttributes_greetingcards = httpResult.data.DATA1;
              }

                //console.log($scope.selectedProductRelationships);
            });
        }
        function getAmazonSubjects() {

            return datacontext.get_amazon_subjects().then(function (httpResult) {
                $scope.amazon_subjects = httpResult.data.data;
            });
        }


        $scope.update_product_attributes = function(data) {
            //console.log(data);
            var payload = {product_id:$scope.product_id,
                          custom_bullet_1:data.custom_bullet_1,
                          custom_bullet_2:data.custom_bullet_2,
                          custom_bullet_3:data.custom_bullet_3,
                          custom_bullet_4:data.custom_bullet_4,
                          custom_bullet_5:data.custom_bullet_5,
                          root_title:data.root_title,
                          frame_type:data.frame_type,
                          orientation:data.orientation,
                          artwork_surface_material:data.artwork_surface_material,
                          import_designation:data.import_designation,
                          item_shape:data.item_shape,
                          base_material_type:data.base_material_type,
                          material_type:data.material_type,
                          target_audience_keywords1:data.target_audience_keywords1,
                          specific_uses_keywords1:data.specific_uses_keywords1,
                          special_features1:data.special_features1,
                          big_commerce_category_id:data.big_commerce_category_id,
                          amazon_subject:data.amazon_subject};
            var paylod_product = {
                                    product_id:$scope.product_id,
                                    product_title:data.product_title,
                                    keyword_group_1:data.keyword_group_1,
                                    product_title:data.product_title,
                                    attributes_update:1,
                                    upd_root_title:data.upd_root_title,
                                    upd_product_source:data.upd_product_source,
                                    content_theme_id:data.content_theme_id,
                                    product_source_id:data.product_source_id,
                                    inside_content: data.inside_content
                              };
          datacontext.update_product_attributes(payload).then(function(httpResult) {
            $scope.attr_update = 1;
            log("Updated");
              //getProductAttributes();
          });

          datacontext.update_product(paylod_product).then(function(httpResult) {

            log("Updated");
              getProductAttributes();
          });
          if(data.upd_root_title){
            var payload = {product_id:$scope.product_id,
                          custom_bullet_1:data.custom_bullet_1,
                          custom_bullet_2:data.custom_bullet_2,
                          custom_bullet_3:data.custom_bullet_3,
                          custom_bullet_4:data.custom_bullet_4,
                          custom_bullet_5:data.custom_bullet_5,
                          root_title:data.root_title,
                          frame_type:data.frame_type,
                          orientation:data.orientation,
                          artwork_surface_material:data.artwork_surface_material,
                          import_designation:data.import_designation,
                          item_shape:data.item_shape,
                          base_material_type:data.base_material_type,
                          material_type:data.material_type,
                          target_audience_keywords1:data.target_audience_keywords1,
                          specific_uses_keywords1:data.specific_uses_keywords1,
                          special_features1:data.special_features1,
                          amazon_subject:data.amazon_subject,
                          keyword_group_1:data.keyword_group_1,
                          product_title:data.product_title,
                          big_commerce_category_id:data.big_commerce_category_id,
                          attributes_update:1,
                            content_theme_id:data.content_theme_id,
                            product_source_id:data.product_source_id};
            return datacontext.update_product_root(payload).then(function(httpResult) {

              log("Updated");
                getProductAttributes();
            });
          }

          if(data.upd_product_source){
            var payload = {
                product_id:$scope.product_id,
                product_source_id:data.product_source_id
            };

            return datacontext.update_product_source(payload).then(function(httpResult) {
                log("Updated");
                getProductAttributes();
            });
          }


        };

        $scope.update_product_attributes_done = function(data) {
              var payload = {product_id:$scope.product_id,
                            custom_bullet_1:data.custom_bullet_1,
                            custom_bullet_2:data.custom_bullet_2,
                            custom_bullet_3:data.custom_bullet_3,
                            custom_bullet_4:data.custom_bullet_4,
                            custom_bullet_5:data.custom_bullet_5,
                            root_title:data.root_title,
                            frame_type:data.frame_type,
                            orientation:data.orientation,
                            artwork_surface_material:data.artwork_surface_material,
                            import_designation:data.import_designation,
                            item_shape:data.item_shape,
                            base_material_type:data.base_material_type,
                            material_type:data.material_type,
                            target_audience_keywords1:data.target_audience_keywords1,
                            specific_uses_keywords1:data.specific_uses_keywords1,
                            special_features1:data.special_features1,
                            big_commerce_category_id:data.big_commerce_category_id,
                            amazon_subject:data.amazon_subject};
              var paylod_product = {product_id:$scope.product_id,
                                    product_title:data.product_title,
                                    keyword_group_1:data.keyword_group_1,
                                    product_title:data.product_title,
                                    description_status_id: 6,
                                    attributes_update:1};
            datacontext.update_product_attributes(payload).then(function(httpResult) {
              $scope.attr_update_done = 1;
              log("Updated");
                //getProductAttributes();
            });

            return datacontext.update_product(paylod_product).then(function(httpResult) {

              log("Updated");
                getProductAttributes();
            });
        };
        $scope.update_product_attributes_done_all_sizes = function (data) {
            var payload = {
                product_id: $scope.product_id,
                description_status_id: 6
            };
            datacontext.update_product_attributes_done_all_sizes(payload)
                .then(function (httpResult) {
                    $scope.attr_update_all = 1;
                    log("All sizes marked Content Done");
                    getProductAttributes();
                });
        };

        $scope.update_product_name_all_sizes = function(data) {
            var payload = {
                product_id: $scope.product_id,
                product_name: data.product_name,
                upd_product_name: 1
            };
            console.log("Product Name Update Payload:", payload);
            return datacontext.update_product_name_all_sizes(payload).then(function(httpResult) {

                var response = httpResult.data || httpResult;

                if (response.success === false) {
                    log(response.message || response.MESSAGE);
                    return;
                }
                log("Updated");
                getProductAttributes();

            });
        };


    }
})();

(function () {
    'use strict';
    var controllerId = 'ProductCustomCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$modal','$scope', ProductCustomCtrl]);

    function ProductCustomCtrl(common, datacontext, $modal, $scope) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.x_axis = 81;
        vm.y_axis = 241;
        vm.width = 241;
        vm.height = 81;
        vm.label = '';
        vm.label_size = 64;
        vm.query = {
            search: '',
            order_by: 'is_forSale',
            order_dir: 'desc'
        };

        // activated via tab
        // activate();

        $scope.$on('refreshProductCustomCtrl', function (event, data) {
            activate();
        });


        function activate() {
            var promises = [

            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Task List View');
                });
        }

    }
})();

(function () {
    'use strict';
    var controllerId = 'ProductSetsCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$modal','$scope', ProductSetsCtrl]);

    function ProductSetsCtrl(common, datacontext, $modal, $scope) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        vm.search_query_set = '';
        vm.search_query_store_id = '1';
        vm.active_spids = '';


        // activated via tab
        // activate();

        $scope.$on('refreshProductSetsCtrl', function (event, data) {
            activate();
        });

        function activate() {
            var promises = [
                getProductSets(),
                get_stores()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Task List View');
                });
        }



        function getProductSets() {
            var payload = {product_id:$scope.product_id};
            return datacontext.getProductSets(payload).then(function (httpResult) {
                vm.productSets = httpResult.data.data;
                vm.productSetsLength = httpResult.data.LENGTH;

            });
        }
        function get_stores() {
            return datacontext.get_stores().then(function(httpResult) {
                vm.stores = httpResult.data.data;
            });
        }
        $scope.search_spids = function(data) {

            var payload = {search_query_set:data.search_query_set,
                            search_query_store_id:data.search_query_store_id,
                          product_id:$scope.product_id};
            return datacontext.search_spids(payload).then(function(httpResult) {

              vm.results = httpResult.data.data;
                //getProductAttributes();
            });
        };
        $scope.delete_set = function(data) {

        };

        $scope.add_spids = function(data) {

            var set_product_ids = '';
            for(var i=0; i < data.length; i++){
              if( set_product_ids.length === 0){
                set_product_ids = data[i];
              }else{
                set_product_ids = set_product_ids +','+data[i];
              }
            }

            var payload = {product_id:$scope.product_id,
                          set_product_ids:set_product_ids};
            return datacontext.add_sets(payload).then(function(httpResult) {
              vm.results = httpResult.data.data;
                //getProductAttributes();
            });
        };

    }
})();

(function () {
    'use strict';
    var controllerId = 'productParentChildCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modal', '$cookies', '$filter', productParentChildCtrl]);

    function productParentChildCtrl(common, datacontext, $scope, $modal, $cookies, $filter) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var vm = this;

        vm.query = {
            search: '',
            store_id:0
        };
        if( angular.isDefined($cookies.get('user_role_id')) ) {
          vm.user_role_id = $cookies.get('user_role_id');
          console.log("vm.user_role_id:"+vm.user_role_id);
        }
        //activate();
        function activate() {
            var promises = [getStoreProductRelationships(),
                get_stores(),
                get_aws_variation_themes(),
                getAllRelations(),
                get_store_products_for_parent()];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Task List View');
                });
        }

        $scope.$on('refreshProductParentChildCtrl', function (event, data) {
            activate();
        });

        $scope.config = {
            autoHideScrollbar: false,
            theme: 'light',
            advanced:{
                updateOnContentResize: true
            },
            setHeight: 400,
            scrollInertia: 0
        };

        function get_stores() {
            return datacontext.get_stores().then(function(httpResult) {
                vm.stores = httpResult.data.data;
            });
        }
        function getAllRelations() {
          var payload = {
              product_id:$scope.product_id,
              master_product_id: $scope.master_product_id
          };

            return datacontext.getAllRelations(payload).then(function(httpResult) {

                vm.allData = httpResult.data.data;
                vm.parent_id = httpResult.data.PARENT_ID;
                vm.pparent_id = httpResult.data.PPARENT_ID;


            });
        }

        $scope.$watch("vm.query.store_id", function(newValue, oldValue){
            // do something
            vm.query.store_id = newValue;
            getStoreProductRelationships();
        });

        function getStoreProductRelationships() {
            var payload = {
                product_id:$scope.product_id,
                relationship_type_id:4,
                is_active_override:1,
                store_product_status_id:1,
                store_id:vm.query.store_id
            };
            return datacontext.getStoreProductRelationships(payload).then(function (httpResult) {
                vm.data = httpResult.data.data;

                return datacontext.get_product_parent_v1({product_id:$scope.product_id}).then(function (parents) {

                    $scope.models = {
                        selected: null,
                        lists: {orphans:[]}
                    };

                    console.log(parents.data);

                    if (parents.data.data.length > 0) {
                        $scope.direct_parent_id = parents.data.data[0].product_parent_id;
                        $scope.master_parent_id = parents.data.data[0].master_parent_id;    
                    } else {
                        $scope.direct_parent_id = 0;
                        $scope.master_parent_id = 0;
                    }
                    

                    for ( var p in parents.data.data ) {
                        $scope.models.lists[parents.data.data[p].product_parent_id] = [];
                    }

                    vm.productRelationships = [];

                    for ( var i in vm.data) {
                        if ( vm.data[i].parent_id ==='' ) {
                            $scope.models.lists.orphans.push(vm.data[i]);
                        } else {
                            if( $scope.models.lists[vm.data[i].parent_id]  === undefined ) {
                                // create empty array
                                $scope.models.lists[vm.data[i].parent_id] = [];
                            }
                            $scope.models.lists[vm.data[i].parent_id].push(vm.data[i]);
                        }
                    }
                });
            });
        }

        function get_aws_variation_themes() {
            return datacontext.get_aws_variation_themes().then(function(httpResult) {
                vm.aws_variation_themes = httpResult.data.data;
            });
        }

        /* not running dragoverCallback yet
        $scope.dragoverCallback = function(event, type) {
            // console.log('dragged over event:', event);
            // console.log('from type:', type);
            // Disallow dropping in the third row. Could also be done with dnd-disable-if.
            return 1;
        };
        */
        function get_store_products_for_parent() {
            return datacontext.get_store_products_for_parent({product_id:$scope.product_id}).then(function(httpResult) {
                vm.parent_spids = httpResult.data.data;

            });
        }
        $scope.dropCallback = function(item, type, listName) {

            var result = item,
                error = {
                    product_id:0,
                    store_id:0,
                    theme:0,
                    missingtheme:0
                };
            //console.log(item.store_product_id + " was dragged from list " + type + " to list " + listName);

            // loop destination list and verify store_id and product_id unique
            if ( listName !== 'orphans') {
                for ( var i in $scope.models.lists[listName] ) {

                    if ( item.product_id === $scope.models.lists[listName][i].product_id ) {
                        result = false;
                        error.product_id = 1;

                    }

                    if ( item.store_id !== $scope.models.lists[listName][i].store_id ){
                        result = false;
                        error.store = 1;
                    }

                    if ( item.aws_variation_theme_id !== $scope.models.lists[listName][i].aws_variation_theme_id ){
                        result = false;
                        error.theme = 1;
                    }

                    if ( ! item.aws_variation_theme_id > 0 ){
                        result = false;
                        error.missingtheme = 1;
                    }
                }
                // add error messages
                if ( error.product_id ) {
                    log("Can't add same product to same parent");
                }
                if ( error.store ) {
                    log("Can't add diff stores to same parent");
                }
                if ( error.theme ) {
                    log("Can't add theme must be same as parent");
                }
                if ( error.missingtheme ) {
                    log("Can't add due to missing theme");
                }
            }

            return result; // return false to disallow drop
        };

        $scope.movedCallback = function(data) {
            // FindParent
            FindParent(data.store_product_id, $scope.models.lists, function (err, payload, theme_id) {
                if (err) {
                    //console.log('error insert', err);
                    return callback(err);
                } else {
                    // update parent id in store product table
                    var payload_store_product = {
                            store_product_id:payload.store_product_id,
                            parent_id:payload.parent_id
                    };

                    // check if dropped items is inactive phantom and activate it
                    if (payload.is_phantom &&
                            payload.store_product_status_id === 2 &&
                            payload.parent_id !== '') {
                        payload_store_product.store_product_status_id = 1;
                    }

                    return datacontext.update_store_product(payload_store_product).then(function () {
                        // kinda a hack, should only do first time store product is added
                        if ( payload.parent_id > 0 ) {
                            var parent_payload = {
                                product_parent_id: payload.parent_id,
                                aws_variation_theme_id: theme_id,
                                store_id: data.store_id
                            };

                            return datacontext.update_product_parent(parent_payload).then(function () {
                                // update refresh Product Parent Child Ctrl
                                $scope.$broadcast('refreshProductParentChildCtrl', 'refresh');
                            });
                        }
                    });
                }
            });

            function FindParent(store_product_id, list, cb) {
                // strange I can't get call back for new location but whatever
                for (var p in list) {
                    var objChildren = list[p];
                    for (var i in objChildren) {
                        if (store_product_id === objChildren[i].store_product_id) {

                            var result = {
                                store_product_id : store_product_id,
                                parent_id : p,
                                is_phantom: objChildren[i].is_phantom,
                                store_product_status_id: objChildren[i].store_product_status_id,
                            };

                            var theme_id = objChildren[i].aws_variation_theme_id;

                            if (result.parent_id === 'orphans') {
                                result.parent_id = '';
                            }
                            return cb(null,result, theme_id);
                        }
                    }
                }
            }
        };

        $scope.createParent = function (product_id) {
            //console.log("$routeParams",$routeParams);

            //product_id = $scope.product_id;
            var modalInstance = $modal.open({
                templateUrl: '/app/products/partials/create_parent.html',
                controller: 'createParentctrl',
                scope: $scope,
                windowClass: 'small',
                resolve: {
                    items: function () {
                        return $scope.product_id;
                    }
                }
            }).result.then(function (result) {

            });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

        $scope.deleteParent = function (data) {
            var payload = {
                product_parent_id: data
            };
            return datacontext.deleteProductParent(payload).then(function () {
                delete $scope.models.lists[data];
            });
        };

        $scope.update_product_variations = function(data){
            var payload = {
                product_id:data.product_id,
                aws_variation_theme_id:data.aws_variation_theme_id,
                aws_variation_1_value:data.aws_variation_1_value,
                aws_variation_2_value:data.aws_variation_2_value
            };

            console.log(payload);

            datacontext.update_product(payload).then(function(httpResult) {
                log("Updated");
            });
        }


        // Model to JSON for demo purpose
        $scope.$watch('models', function(model) {
            $scope.modelAsJson = angular.toJson(model, true);
        }, true);

        $scope.create_product_relationship = function (payload) {
            return datacontext.create_product_relationship(payload).then(function () {
                getProductRelationships();
            });
        };

        $scope.deleteProductRelationship = function (payload) {
            return datacontext.deleteProductRelationship(payload).then(function () {
                getProductRelationships();
            });
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'createParentctrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modalInstance',  createParentctrl]);

    function createParentctrl(common, datacontext, $scope, $modalInstance) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var vm = this;
        // Pushes input to scope

        $scope.store_id = 9;
        $scope.theme_id = 134;

        //$scope.product_id = 0;
        $scope.ok = function (store_id,theme_id, parent_title) {

            var payload = {
                product_id: $scope.product_id,
                store_id: store_id,
                theme_id: theme_id,
                parent_title: parent_title
            };

            return datacontext.createProductParent(payload).then(function (httpResult) {
                datacontext.getAllRelations(payload).then(function(httpResult) {
                    vm.allData = httpResult.data.data;
                    vm.parent_id = httpResult.data.PARENT_ID;
                });
                $modalInstance.close();
            });

        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }

    function getAllRelations() {
      var payload = {
          product_id:$scope.product_id
      };

        return datacontext.getAllRelations(payload).then(function(httpResult) {
            vm.allData = httpResult.data.data;
            vm.parent_id = httpResult.data.PARENT_ID;
        });
    }

})();
(function() {
    'use strict';
    var controllerId = 'createPhantomModalCtrl';
    angular.module('app').controller(controllerId, ['common','datacontext', '$scope', '$modalInstance','payload', createPhantomModalCtrl]);

    function createPhantomModalCtrl(common, datacontext, $scope, $modalInstance, payload) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        // Pushes input to scope
        $scope.submitted = 0;
        $scope.is_duplicate = 0;
        $scope.IsLoading = 0;
        $scope.IsDone = 0;
        $scope.parentMatch = 1;
        $scope.IsDuplicate = 0;
        $scope.detailsVisible = 0;

        // Set Defaults
        $scope.item = {asin:''};
        $scope.payload = payload;
        $scope.search = {};
        $scope.results = {store_id:1};

        datacontext.get_aws_variation_themes().then(function(httpResult) {
            $scope.aws_variation_themes = httpResult.data.data;
        });

        $scope.showDetails = function() {
            $scope.detailsVisible = !$scope.detailsVisible;
        };

        datacontext.get_stores({"marketplace_id":1}).then(function(httpResult) {
            $scope.amazon_stores = httpResult.data.data;
        });

        datacontext.get_product_categories().then(function (httpResult) {
            $scope.product_categories = httpResult.data;
        });

        // Find ASIN
        $scope.find_asin = function(search) {

            $scope.IsLoading = 1;
            // check if asin already in system
            datacontext.get_store_products({store_sku: search.asin,queryType:'array'}).then(function(dupcheck) {

                if (dupcheck.data.data.length) {
                    $scope.IsDone = 1;
                    $scope.IsLoading = 0;
                    $scope.IsDuplicate = 1;

                    $scope.results = {
                        success:1,
                        data: dupcheck.data.data[0].store_product_id
                    }
                } else {
                    datacontext.mwsFullLookup({asin: search.asin}).then(function (httpResult) {
                        $scope.IsDone = 1;
                        $scope.IsLoading = 0;
                        $scope.payload.step = 2;

                        var skip_list = [134, 96, 97, 127];

                        if ( httpResult.data.aws_variation_theme_id === '' ) {
                            httpResult.data.data.aws_variation_theme_id = 134;
                        } else {
                            for (var i in skip_list) {
                                if (skip_list.hasOwnProperty(i)) {
                                    // don't bother with color,size,size-color,color-size as its the default
                                    httpResult.data.data.aws_variation_theme_id = 134;
                                    httpResult.data.aws_variation_1_value = '';
                                    httpResult.data.aws_variation_2_value = '';
                                }
                            }
                        }
                        $scope.results = httpResult.data;
                        // hard code store id for now
                        $scope.results.data.store_id = "";

                        if ($scope.results.data.product_parent_id === payload.product_parent_id) {
                            $scope.parentMatch = 0;
                        } else {
                            $scope.results.data.product_parent_id = "";
                        }
                    });
                }
            });
        };

        $scope.createPhantomProduct = function(new_asin) {

            // chain create
            // product
            // store product
            // relationship
            var product_payload = {
                product_name:new_asin.data.title,
                is_active_override:1,
                asin_iscomplete:1,
                product_title:new_asin.data.title,
                category_id:payload.data.category_id,
                upc:new_asin.data.upc,
                height:new_asin.data.height,
                width:new_asin.data.width,
                weight:new_asin.data.weight,
                price:new_asin.data.price,
                msrp:new_asin.data.price * 2,
                relationship_status_id:3,
                is_phantom:1,
                fit_to_sell:0
            };

            var skip_list = [134,96,97,127];

            for (var i in skip_list) {
                if (skip_list.hasOwnProperty(i)) {
                    // don't bother with color,size,size-color,color-size as its the default
                    new_asin.data.aws_variation_theme_id = '';
                    new_asin.data.aws_variation_1_value = '';
                    new_asin.data.aws_variation_2_value = '';
                }
            }

            /// prep data for store product creation
            var store_product_payload = {
                product_id:null,
                product_parent_id: new_asin.data.product_parent_id,
                store_product_status_id:1,
                store_sku: new_asin.data.asin,
                store_id: new_asin.data.store_id,
                amz_parent_asin:new_asin.data.amz_parent_asin,
                aws_variation_theme_id: new_asin.data.aws_variation_theme_id,
                aws_variation_1_value: new_asin.data.aws_variation_1_value,
                aws_variation_2_value: new_asin.data.aws_variation_2_value,
                amz_sales_rank: new_asin.data.amz_sales_rank,
                mp_brand: new_asin.data.mp_brand,
                mp_manufacturer: new_asin.data.mp_manufacturer,
                mp_category: new_asin.data.mp_category,
                mp_department: new_asin.data.mp_department,
                mp_similar: new_asin.data.mp_similar
            };

            var product_image_payload = {
                image_url:new_asin.data.image_url,
                dstBucket:"image-pending-resize",
                dstPath:"",
                dstFilename:null,
                contentType:"image/jpeg"
            };

            var relationship_payload = {
                product_id:payload.data.product_id,
                linked_product_id:null,
                type_id:4
            };

            var new_product = {};
            var new_store_product = {};
            var new_product_relationship = {};


            datacontext.create_product(product_payload).then(function(new_product){

                // prep data for store product creation
                store_product_payload.product_id = new_product.data.data;

                return datacontext.create_store_product(store_product_payload);
            })
            .then(function(new_store_product){


                relationship_payload.linked_product_id = store_product_payload.product_id;

                // prep relationship creation
                return datacontext.create_product_relationship(relationship_payload);
            })
            .then(function(){
                // upload image
                product_image_payload.dstFilename = store_product_payload.product_id + '.jpg';

                return datacontext.web_image_scraper(JSON.stringify(product_image_payload));
            })
            .then(function(){
                //Finally do something with promise, or even return this
                $modalInstance.close();
            });
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }
})();


(function() {
    'use strict';
    var controllerId = 'SetAttributeWizardCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$routeParams', '$location', SetAttributeWizardCtrl]);

    function SetAttributeWizardCtrl(common, datacontext, $scope, $routeParams, $location) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;

        vm.title = 'Product Attribute Wizard';
        vm.product = {};
        vm.attributes = {};
        $scope.prev = {};

        activate();

        function activate() {
            var promises = [
                get_products()
            ];
            common.activateController(promises, controllerId)
                .then(function() {
                    // log('Activated Product Detail View');
                });
        }

        // get next product
        function get_products() {

            if ( angular.isDefined($routeParams.pid) && $routeParams.pid > 0 ) {
                var payload = {
                    queryType:'array-count',
                    product_id: $routeParams.pid,
                    order_by:'sales_last_30_days',
                    order_dir:'desc',
                    page:1,
                    limit:1
                };
            } else {
                var payload = {
                    queryType:'array-count',
                    attribute_check_needed: 1,
                    order_by:'sales_last_30_days',
                    order_dir:'desc',
                    page:1,
                    limit:1
                };
            }

            datacontext.get_products(payload).then(function (httpResult) {
                if ( httpResult.data.total > 0 ) {

                    // made scope to work with other includes
                    $scope.product = httpResult.data.data[0];

                    // lock product attributes
                    var payload = {
                        product_id: $scope.product.product_id,
                        attribute_check_locked_by:$scope.currentUser.user_id
                    };

                    datacontext.update_product(payload).then(function() {

                        var payload = {
                            product_id: $scope.product.product_id
                        };

                        datacontext.get_product_attributes(payload).then(function (httpResult) {
                            vm.attributes =  _.chain(httpResult.data.data)
                                .groupBy("parent_name")
                                .pairs()
                                .map(function (currentItem) {
                                    return _.object(_.zip(["parent", "children"], currentItem));
                                })
                                .value();

                            $scope.active_attributes = [];

                            angular.forEach(httpResult.data.data, function(value) {
                                if ( value.attribute_product_link_id||0 > 0) {
                                    $scope.active_attributes.push(value);
                                }
                            });

                            $scope.current_attributes = angular.copy($scope.active_attributes);
                        });
                    });
                }
            });
        }

        $scope.$watch(
            '[product.product_name, product.variant_name]',
            function(newValues, oldValues){
                if (newValues === oldValues) { return; } // AKA first run

                var title = $scope.product.product_name;

                if (newValues) {
                    // calculate product title
                    if( $scope.product.variant_name.length ) {
                        title =  $scope.product.product_name + ' ' + $scope.product.variant_name;
                    }

                    if($scope.product.category_product_display_name.length !== 0) {
                        title = title + ' ' + $scope.product.category_product_display_name;
                    }

                    if($scope.product.show_size_in_title && $scope.product.width > 0 && $scope.product.height > 0){
                        title = title + ' - ' + $scope.product.width + 'x' + $scope.product.height;
                    }

                    $scope.product.product_title = title.replace(/[^A-Za-z0-9/&/%/(/)/-//./!/]/g, " ");
                }

            }, true);

        $scope.update = function () {
            var payload = {
                product_id:$scope.product.product_id,
                product_name:$scope.product.product_name,
                product_title:$scope.product.product_title,
                variant_name:$scope.product.variant_name,
                keyword_group_1:$scope.product.keyword_group_1,
                attribute_check_needed:0
            };

            datacontext.update_product(payload).then(function() {

                var new_attributes = angular.copy($scope.active_attributes);
                var del_attributes = [];

                angular.forEach( $scope.current_attributes, function(check) {
                    var action = 'delete';
                    var count = 0;
                    angular.forEach( $scope.active_attributes, function(changed) {
                        if (check.attribute_id === changed.attribute_id) {
                            // not change remove from new_attributes array
                            action = 'match';
                            new_attributes.splice(count, 1);
                        }
                        count ++;
                    });

                    if ( action === 'delete') {
                        del_attributes.push(check);
                    }
                });

                angular.forEach(del_attributes, function(item) {
                    var payload = {
                        attribute_id:item.attribute_id,
                        attribute_name:item.attribute_name,
                        product_id:$scope.product.product_id
                    };
                    datacontext.delete_product_attribute(payload).then(function() {});
                });

                angular.forEach(new_attributes, function(item) {
                    var payload = {
                        attribute_id:item.attribute_id,
                        attribute_name:item.attribute_name,
                        product_id:$scope.product.product_id
                    };

                    datacontext.create_product_attribute(payload).then(function() {});
                });

                // save previous
                $scope.prev = $scope.product;
                // get next product
                // Clear the current search
                if ( angular.isDefined($routeParams.pid) && $routeParams.pid.length > 0 ) {
                    $location.path('/products/attributes_wizard/0');
                }

                get_products();
            });
        };
    }
})();

(function() {
    'use strict';
    var controllerId = 'CategoryListCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', '$modal', 'NgTableParams', CategoryListCtrl]);
    function CategoryListCtrl(common, datacontext, $scope, $location, $modal, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);

        var vm = this;
        vm.startSearch = 0;
        vm.title = 'Product Categories List';
        vm.query = {
            queryType:'array-count',
            search:'',
            status_id:'',
            page:1,
            limit:50
        };

        // selectively update
        vm.urlQuery  = $location.search();
        var url_used = 0;

        // loop and set url var
        for ( var i in vm.urlQuery ){
            vm[i] = vm.urlQuery[i];
            url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {

            for ( var i in newValue ) {
            	if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                     vm.startSearch ++;

                     if( oldValue[i] >= 0 || oldValue[i] == "" || angular.isUndefined(oldValue[i])  == true ){

                    	 get_product_categories_v1();
                       get_product_lead_time_group();
                       get_product_lead_time_group_v1();
                       get_faster_lead_times();
                     }else{
                         return "";
                     }
                 }

                /*if ( i !== 'page' && vm.grid == 0 && newValue[i] !== oldValue[i]) {
                    vm.startSearch ++;
                    vm.grid = 0;
                    get_product_parent();
                } */
            }
            vm.grid = 0;
        });

        activate();

        function activate() {
            var promises = [
                get_product_categories_v1(),
                get_product_lead_time_group(),
                get_product_lead_time_group_v1(),
                get_faster_lead_times()];
            common.activateController(promises, controllerId)
                .then(function() {
                    //  log('Activated Product List View');
                });
        }
        function get_product_lead_time_group() {
            return datacontext.get_product_lead_time_group().then(function (httpResult) {
                vm.lead_time_groups = httpResult.data;
            });
        }
        function get_product_lead_time_group_v1() {
            return datacontext.get_product_lead_time_group_v1().then(function (httpResult) {
                vm.lead_time_groups_v1 = httpResult.data;
            });
        }
        function get_faster_lead_times() {
            return datacontext.get_faster_lead_times().then(function (httpResult) {
              console.log(httpResult.data);
                vm.faster_lead_times = httpResult.data.data;
                vm.faster_lead_times_total = httpResult.data.TOTAL;

            });
        }

        function get_product_categories_v1() {
        	vm.grid = 0;
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // initial page size
            },{
                getData: function(params) {
                    vm.query.page = params.page;
                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }
                    // ajax request to api
                    return datacontext.get_product_categories_list_v1(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.TOTAL);
                        vm.results_total = httpResult.data.TOTAL;
                        // set new data
                        vm.results = httpResult.data.data;
                        vm.grid = 1;
                        return httpResult.data.data;
                    });
                }
            });
        }
        $scope.upd_leadtime = function (group_id, lead_time,group_name) {
            // create PS
            $scope.lead_time_values = {
                category_id:group_id,
                lead_time:lead_time,
                group_name:group_name
            };
            var modalInstance = $modal.open({
                templateUrl: '/app/products/partials/upd_lead_time.html',
                controller:"updLeadtimeModalCtrl",
                resolve: {
                    lead_time_values: function () {
                        return $scope.lead_time_values;
                    }
                },
                backdrop: 'static'
            }).result.then(function(result){
                    get_product_categories_v1();
                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };
        $scope.edit_leadtime = function (category_id, lead_time,category_name) {
            // create PS
            $scope.lead_time_values = {
                category_id:category_id,
                lead_time:lead_time,
                category_name:category_name
            };
            var modalInstance = $modal.open({
                templateUrl: '/app/products/partials/edit_lead_time.html',
                controller:"editLeadtimeModalCtrl",
                resolve: {
                    lead_time_values: function () {
                        return $scope.lead_time_values;
                    }
                },
                backdrop: 'static'
            }).result.then(function(result){
                    get_product_categories_v1();
                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };
    }
})();
(function() {
    'use strict';
    var controllerId = 'ContentListCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$location', '$modal', 'NgTableParams', ContentListCtrl]);
    function ContentListCtrl(common, datacontext, $scope, $location, $modal, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');

        var vm = this;
        vm.startSearch = 0;
        vm.title = 'Content Themes List';
        vm.query = {
            queryType:'array-count',
            search:'',
            status_id:'',
            page:1,
            limit:50
        };

        // selectively update
        vm.urlQuery  = $location.search();
        var url_used = 0;

        // loop and set url var
        for ( var i in vm.urlQuery ){
            vm[i] = vm.urlQuery[i];
            url_used = 1;
        }

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {

            for ( var i in newValue ) {
            	if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                     vm.startSearch ++;

                     if( oldValue[i] >= 0 || oldValue[i] == "" || angular.isUndefined(oldValue[i])  == true ){

                    	 get_content_themes();
                     }else{
                         return "";
                     }
                 }

                /*if ( i !== 'page' && vm.grid == 0 && newValue[i] !== oldValue[i]) {
                    vm.startSearch ++;
                    vm.grid = 0;
                    get_product_parent();
                } */
            }
            vm.grid = 0;
        });

        activate();

        function activate() {
            var promises = [
                get_content_themes()];
            common.activateController(promises, controllerId)
                .then(function() {
                    //  log('Activated Product List View');
                });
        }

        function get_content_themes() {
        	vm.grid = 0;
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // initial page size
            },{
                getData: function(params) {
                    vm.query.page = params.page;
                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }
                    // ajax request to api
                    return datacontext.get_content_themes(vm.query).then(function (httpResult) {
                        params.total(httpResult.data.TOTAL);
                        vm.results_total = httpResult.data.TOTAL;
                        // set new data
                        console.log(httpResult);
                        vm.results = httpResult.data;
                        vm.grid = 1;
                        return httpResult.data.data;
                    });
                }
            });
        }

        $scope.refresh_pid_cnt = function (){
          datacontext.update_theme_pid_cnt().then(function (httpResult) {
            if(httpResult.data.success === true){
                log_success("PID count updated");
            }else{
                log_success("PID count is not updated");
            }
            get_content_themes();
          });

        };

        $scope.refresh_active_ct_pid_cnt = function() {
            datacontext.update_active_ct_pid_cnt().then(function (httpResult) {
                if(httpResult.data.success === true){
                    log_success("sales updated");
                }else{
                    log_success("sales is snot updated");
                }
                get_content_themes();
            });
        };

        $scope.add_theme = function () {
            // create PS
            $scope.ps_create = true;
            var modalInstance = $modal.open({
                templateUrl: '/app/products/partials/add_theme.html',
                controller:"addThemeModalCtrl",
                resolve: {
                    ps_create: function () {
                        return $scope.ps_create;
                    }
                },
                backdrop: 'static'
            }).result.then(function(result){
                    get_content_themes();
                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };
        $scope.edit_theme = function (theme_id, theme_value, content_keywords, spid_cnt, subject_id, amazon_subject) {
            // create PS
            $scope.theme_values = {
                theme_id:theme_id,
                theme_value:theme_value,
                content_keywords:content_keywords,
                spid_cnt:spid_cnt,
                subject_id:subject_id,
                amazon_subject:amazon_subject
            };

            var modalInstance = $modal.open({
                templateUrl: '/app/products/partials/edit_theme.html',
                controller:"editThemeModalCtrl",
                resolve: {
                    theme_values: function () {
                        return $scope.theme_values;
                    }
                },
                backdrop: 'static'
            }).result.then(function(result){
                    get_content_themes();
                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };   
    }
})();

(function() {
    'use strict';
    var controllerId = 'productSourceCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$cookies', '$modal', '$location', 'NgTableParams', productSourceCtrl]);
    function productSourceCtrl(common, datacontext, $scope, $cookies, $modal, $location, NgTableParams) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');

        var vm = this;
        vm.startSearch = 0;
        vm.title = 'Product Source List';
        vm.query = {
            queryType:'array-count',
            search:'',
            status_id:'',
            license_type:'',
            product_type:'',
            wholesale:'',
            page:1,
            limit:500
        };

        if(window.location.href.match('products/ps/')){
            $("body").addClass("removeScroll_PS");
        };

        $scope.$watchCollection("vm.query",function (newValue, oldValue) {

            for ( var i in newValue ) {
                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                    vm.startSearch ++;
                    if( oldValue[i] >= 0 || oldValue[i] == "" || oldValue[i] < 0 || angular.isUndefined(oldValue[i])  == true ){

                        vm.grid = 0;
                        get_product_source_list();

                    }else{
                        return "";
                    }

                }
            }
            vm.grid = 0;
        });

        activate();

        function activate() {
            var promises = [
                get_product_source_list()];
            common.activateController(promises, controllerId)
                .then(function() {
                    //  log('Activated Product List View');
                });
        }

        function get_product_source_list() {
        	vm.grid = 0;
            vm.tableParams = new NgTableParams({
                count: vm.query.limit // initial page size
            },{
                getData: function(params) {
                    vm.query.page = params.page;
                    vm.query.list = 1;
                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query.order_dir = params.sorting()[key];
                    }
                    // ajax request to api
                    return datacontext.get_product_source_list_v1(vm.query).then(function (httpResult) {
                      console.log(httpResult.data)
                        params.total(httpResult.data.TOTAL);
                        vm.results_total = httpResult.data.TOTAL;
                        // set new data
                        vm.results = httpResult.data.data;
                        vm.grid = 1;
                        return httpResult.data.data;
                    });
                }
            });
        }

        $scope.refresh_ps_pid_cnt = function (){
            datacontext.update_ps_pid_cnt().then(function (httpResult) {
                if (httpResult.data.success === true) {
                    log_success("PID Count updated");
                } else {
                    log_success("PID Count not updated");
                }
                get_product_source_list();
            });
        };

        $scope.refresh_active_ps_pid_cnt = function (){
            datacontext.update_active_ps_pid_cnt().then(function (httpResult) {
                if (httpResult.data.success === true){
                    log_success("Sales Data updated");
                } else {
                    log_success("Sales Data not updated");
                }
                get_product_source_list();
            });
        };

        $scope.create_ps = function () {
            // create PS
            $scope.ps_create = true;
            var modalInstance = $modal.open({
                templateUrl: '/app/products/partials/ps_create_modal.html',
                controller:"psCreateModalCtrl",
                resolve: {
                    ps_create: function () {
                        return $scope.ps_create;
                    }
                }
            }).result.then(function(result){
                    get_product_source_list();
                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };

        $scope.edit_prdtsource = function (product_source_id, product_source,start_date,end_date,advance_paid,ipe_notes,posters_approved,frames_approved,mugs_approved,canvas_approved,blacklights_approved,calendars_approved,shirts_approved,totes_ok,notebooks_ok,cards_ok,wholesale_ok,coloring_books_ok,puzzles_ok,ps_notes) {
            vm.user_id = $cookies.get('user_id');
            console.log(vm.user_id);

            $scope.source_values = {
                product_source_id:product_source_id,
                product_source:product_source,
                start_date:start_date,
                end_date:end_date,
                advance_paid:advance_paid,
                ipe_notes:ipe_notes,
                posters_approved:posters_approved,
                frames_approved:frames_approved,
                mugs_approved:mugs_approved,
                canvas_approved:canvas_approved,
                blacklights_approved:blacklights_approved,
                calendars_approved:calendars_approved,
                shirts_approved:shirts_approved,
                totes_ok:totes_ok,
                notebooks_ok:notebooks_ok,
                cards_ok:cards_ok,
                wholesale_ok:wholesale_ok,
                coloring_books_ok:coloring_books_ok,
                puzzles_ok:puzzles_ok,
                ps_notes:ps_notes,
                userr_id:vm.user_id
            };

            var modalInstance = $modal.open({
                templateUrl: '/app/products/partials/edit_productsource.html',
                controller:"psEditModalCtrl",
                resolve: {
                    source_values: function () {
                        return $scope.source_values;
                    }
                },
                backdrop: 'static'
            }).result.then(function(result){
                    get_product_source_list();
                });

            vm.cancel = function () {
                modalInstance.dismiss('cancel');
            };
        };
    }
})();

(function () {
    'use strict';
    var controllerId = 'psEditModalCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$cookies', '$modal', '$modalInstance', 'source_values', psEditModalCtrl]);

    function psEditModalCtrl(common, datacontext, $scope, $cookies, $modal, $modalInstance, source_values) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var vm = this;
        // Pushes input to scope
        $scope.source_values = source_values;
        console.log(source_values);

        //vm.user_id = $cookies.get('user_id');
        //console.log(vm.user_id);

        $scope.ok = function (product_source_id,product_source,start_date,end_date,advance_paid,ipe_notes,posters_approved,frames_approved,mugs_approved,canvas_approved,blacklights_approved,calendars_approved,shirts_approved,totes_ok,notebooks_ok,cards_ok,wholesale_ok,coloring_books_ok,puzzles_ok,ps_notes,user_id) {
            
            console.log("user id: " +user_id);

            var payload = {
                product_source_id: product_source_id,
                product_source: product_source,
                start_date:start_date,
                end_date:end_date,
                advance_paid:advance_paid,
                ipe_notes:ipe_notes,
                posters_approved:posters_approved,
                frames_approved:frames_approved,
                mugs_approved:mugs_approved,
                canvas_approved:canvas_approved,
                blacklights_approved:blacklights_approved,
                calendars_approved:calendars_approved,
                shirts_approved:shirts_approved,
                totes_ok:totes_ok,
                notebooks_ok:notebooks_ok,
                cards_ok:cards_ok,
                wholesale_ok:wholesale_ok,
                coloring_books_ok:coloring_books_ok,
                puzzles_ok:puzzles_ok,
                ps_notes:ps_notes,
                user_id:user_id
            };

            return datacontext.editProductSource(payload).then(function (httpResult) {
                console.log(httpResult.data);
                if(httpResult.data === "false"){
                    $scope.error_message = "Product Source already exists!";
                } else{
                    $modalInstance.close();
                }
            });
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        }
    };
})();

(function () {
    'use strict';
    var controllerId = 'psCreateModalCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modal', '$modalInstance',  psCreateModalCtrl]);

    function psCreateModalCtrl(common, datacontext, $scope, $modal, $modalInstance) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var vm = this;
        // Pushes input to scope

        //$scope.product_id = 0;
        $scope.ok = function (product_source) {
          console.log(product_source);
          var payload = {
              product_source: product_source
          };
          return datacontext.createProductSource(payload).then(function (httpResult) {
            console.log(httpResult.data);
            if(httpResult.data === "false"){
              //get_product_source_list();
              $scope.error_message = "Product Source already exists!";
            }else{
              //get_product_source_list();
              $modalInstance.close();
            }
              //
          });

        };
        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }

})();

(function () {
    'use strict';
    var controllerId = 'editThemeModalCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modal', '$modalInstance', 'theme_values',  editThemeModalCtrl]);

    function editThemeModalCtrl(common, datacontext, $scope, $modal, $modalInstance, theme_values) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var vm = this;
        // Pushes input to scope
        $scope.theme_values = theme_values;
        console.log(theme_values);

        activate();

        function activate() {
            var promises = [
                get_amazon_subjects_list()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    //log('Activated Store product List View');
                });
        }

        //$scope.product_id = 0;
        $scope.ok = function (theme_id,theme_value,content_keywords,spid_cnt,subject_id,amazon_subject) {
            console.log(theme_value);
            console.log(content_keywords);
            console.log(subject_id);

            var payload = {
                theme_id: theme_id,
                theme_value: theme_value,
                content_keywords:content_keywords,
                spid_cnt:spid_cnt,
                subject_id:subject_id,
                amazon_subject:amazon_subject
            };

            return datacontext.editContentTheme(payload).then(function (httpResult) {
                console.log(httpResult.data);
                if(httpResult.data === "false"){
                    //get_product_source_list();
                    $scope.error_message = "Content theme already exists!";
                }else{
                    //get_product_source_list();
                    $modalInstance.close();
                }
            //
            });
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

        function get_amazon_subjects_list() {
            return datacontext.get_amazon_subjects_list().then(function (httpResult) {
                //console.log(httpResult.data);
                $scope.amazon_subjects = httpResult.data;
            });
        }

        return datacontext.get_wayfair_subjects_list().then(function (httpResult) {
            //console.log(httpResult.data);
            $scope.wayfair_subjects = httpResult.data;
        });

    }

})();
(function () {
    'use strict';
    var controllerId = 'addThemeModalCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modal', '$modalInstance',  addThemeModalCtrl]);

    function addThemeModalCtrl(common, datacontext, $scope, $modal, $modalInstance) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var vm = this;
        // Pushes input to scope


        //$scope.product_id = 0;
        $scope.ok = function (theme_value,content_keywords) {
          console.log(theme_value);
          console.log(content_keywords);
          var payload = {
              theme_value: theme_value,
              content_keywords:content_keywords
          };
          return datacontext.createContentTheme(payload).then(function (httpResult) {
            console.log(httpResult.data);
            if(httpResult.data === "false"){
              //get_product_source_list();
              $scope.error_message = "Content theme already exists!";
            }else{
              //get_product_source_list();
              $modalInstance.close();
            }
              //
          });

        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }

})();
(function () {
    'use strict';
    var controllerId = 'updLeadtimeModalCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modal', '$modalInstance', 'lead_time_values',  updLeadtimeModalCtrl]);

    function updLeadtimeModalCtrl(common, datacontext, $scope, $modal, $modalInstance, lead_time_values) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var vm = this;
        // Pushes input to scope
        $scope.lead_time_values = lead_time_values;
        console.log(lead_time_values);
        //$scope.product_id = 0;
        $scope.ok = function (lead_time,group_id) {

          var payload = {
            group_id: group_id,
            lead_time: lead_time
          };
          return datacontext.updLeadTime(payload).then(function (httpResult) {
            console.log(httpResult.data);
            $modalInstance.close();

              //
          });

        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }

})();
(function () {
    'use strict';
    var controllerId = 'editLeadtimeModalCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$modal', '$modalInstance', 'lead_time_values',  editLeadtimeModalCtrl]);

    function editLeadtimeModalCtrl(common, datacontext, $scope, $modal, $modalInstance, lead_time_values) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var vm = this;
        // Pushes input to scope
        $scope.lead_time_values = lead_time_values;
        console.log(lead_time_values);
        //$scope.product_id = 0;
        $scope.ok = function (lead_time,category_id) {

          var payload = {
            category_id: category_id,
            lead_time: lead_time
          };
          return datacontext.editLeadTime(payload).then(function (httpResult) {
            console.log(httpResult.data);
            $scope.message = "lead time updated!";
            log_success("lead time updated!");
            $modalInstance.close();

              //
          });

        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };

    }

})();

(function () {
    'use strict';
    var controllerId = 'allpodordersCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope', '$cookies','$location','$routeParams','NgTableParams', allpodordersCtrl]);
    function allpodordersCtrl(common, datacontext, $scope, $cookies, $location,$routeParams, NgTableParams) {
        console.log('called');
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        var vm = this;
        vm.startSearch = 0;
        vm.user_id = $cookies.get('user_id');
        console.log(vm.user_id);
        vm.product_id = $routeParams.pid;
        // create empty structure for search items
        vm.query = {
            queryType:'array-count',
            search:'',
            product_id:vm.product_id,
            order_by:'o.mp_ship_latest_by',
            order_dir:'asc',
            page:1,
            limit:30
        };
        // selectively update
        vm.urlQuery  = $location.search();
        var url_used = 0;

        // loop and set url var
        for ( var i in vm.urlQuery ){
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }
            url_used = 1;
        }
        $scope.$watchCollection("vm.query",function (newValue, oldValue) {

            for ( var i in newValue ) {
                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                    vm.startSearch ++;
                    if( oldValue[i] >= 0 || oldValue[i] == "" || oldValue[i] < 0 || angular.isUndefined(oldValue[i])  == true ){
                        get_pod_orders();
                    }else{
                        return "";
                    }

                }
            }

        });
        activate();

        function activate() {
            var promises = [
                get_pod_orders()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Store Products View');
                });
        }

        // function get_all_pods() {
        //   console.log(vm.query);
        //     return datacontext.get_all_pods(vm.query).then(function(httpResult) {
        //         vm.results = httpResult.data.data;
        //         vm.results_total = httpResult.data.TOTAL;
        //     });
        // }
        function get_pod_orders() {

            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    //vm.query.count = params.count;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query[key] = true;
                        vm.query.order_dir = params.sorting()[key];
                    }
                    log_success("Searching");

                    // ajax request to api
                    return datacontext.get_pod_orders(vm.query).then(function (httpResult) {
                      vm.results = httpResult.data.data;
                      vm.results_total = httpResult.data.TOTAL;
                      vm.results_cnt = httpResult.data.CNT_PICKLIST;
                      vm.results_ptitle = httpResult.data.PRODUCT_TITLE;

                      if(angular.isDefined(httpResult.data.PRODUCT_ID)){
                        var urlString = '/#/podorders/' + httpResult.data.PRODUCT_ID;
                        //window.location.href = urlString;
                        /*if (history.pushState) {
                            history.pushState('', '', urlString);
                        }*/
                      }

                      return httpResult.data.data;
                    });
                }
            });
        }
        $scope.create_picklist = function (pickpack_type_id,product_id) {
          //console.log(pickpack_type_id);
          //console.log(product_id);
          vm.query = {
                    queryType:'array-count',
                    pickpack_type_id:pickpack_type_id,
                    product_id:product_id,
                    page:1,
                    limit:50
                };
          return datacontext.populate_picklist_pid(vm.query).then(function (httpResult) {
            vm.results = httpResult.data.data;
            if(angular.isDefined(httpResult.data.data.pickpack_slip_id)){
              var urlString = '/#/pickpack/details/' + httpResult.data.data.pickpack_slip_id;
              window.location.href = urlString;
            }
            return httpResult.data.data;
            get_pod_orders();
          });
          //console.log(vm.query);

        }

    }
})();
(function () {
    'use strict';
    var controllerId = 'allpodsCtrl';
    angular.module('app').controller(controllerId, ['common', 'datacontext', '$scope','$location','NgTableParams', allpodsCtrl]);
    function allpodsCtrl(common, datacontext, $scope, $location, NgTableParams) {
        console.log('called');
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var log_success = getLogFn(controllerId,'success');
        var log_error = getLogFn(controllerId,'error');

        var vm = this;
        vm.startSearch = 0;
        vm.store_products = [];
        // create empty structure for search items
        vm.query = {
            queryType:'array-count',
            search:'',
            category_id:'',
            search_by_id:0,
            order_by:'count(opi.product_id)',
            order_dir:'desc',
            page:1,
            limit:30
        };
        // selectively update
        vm.urlQuery  = $location.search();
        var url_used = 0;

        // loop and set url var
        for ( var i in vm.urlQuery ){
            if ( i !=='queryType') {
                vm.query[i] = vm.urlQuery[i];
            }
            url_used = 1;
        }
        $scope.$watchCollection("vm.query",function (newValue, oldValue) {

            for ( var i in newValue ) {
                if ( i !== 'page' && newValue[i] !== oldValue[i]) {
                    vm.startSearch ++;
                    if( oldValue[i] >= 0 || oldValue[i] == "" || oldValue[i] < 0 || angular.isUndefined(oldValue[i])  == true ){
                        get_all_pods();
                    }else{
                        return "";
                    }

                }
            }

        });
        activate();

        function activate() {
            var promises = [
                get_all_pods(),
                getProductCategories()
            ];
            common.activateController(promises, controllerId)
                .then(function () {
                    // log('Activated Store Products View');
                });
        }

        // function get_all_pods() {
        //   console.log(vm.query);
        //     return datacontext.get_all_pods(vm.query).then(function(httpResult) {
        //         vm.results = httpResult.data.data;
        //         vm.results_total = httpResult.data.TOTAL;
        //     });
        // }
        function get_all_pods() {

            vm.tableParams = new NgTableParams({
                count: vm.query.limit // count per page
            }, {
                getData: function(params) {

                    vm.query.page = params.page;
                    //vm.query.count = params.count;

                    for(var key in params.sorting()) {
                        vm.query.order_by = key;
                        vm.query[key] = true;
                        vm.query.order_dir = params.sorting()[key];
                    }
                    log_success("Searching");

                    // ajax request to api
                    return datacontext.get_all_pods(vm.query).then(function (httpResult) {
                      vm.results = httpResult.data.data;
                      vm.results_total = httpResult.data.TOTAL;
                      vm.total_pid_cnt = httpResult.data.TOTAL_PID_CNT;
                      vm.total_today_due_count = httpResult.data.TOTAL_TODAY_DUE_COUNT;
                      return httpResult.data.data;
                    });
                }
            });
        }
        $scope.chgGroupby = function (category_id,pod_only) {
          console.log(category_id);
          console.log(pod_only);
          vm.query = {
                    queryType:'array-count',
                    category_id:category_id,
                    pod_only:pod_only,
                    order_by:'count(opi.product_id)',
                    order_dir:'desc',
                    page:1,
                    limit:50
                };
          get_all_pods();
        }
        $scope.chgCategory = function (category_id,pod_only) {
          console.log(category_id);
          console.log(pod_only);
          vm.query = {
                    queryType:'array-count',
                    category_id:category_id,
                    pod_only:pod_only,
                    order_by:'count(opi.product_id)',
                    order_dir:'desc',
                    page:1,
                    limit:50
                };
          get_all_pods();
        }
        function getProductCategories() {
            return datacontext.get_product_categories().then(function (httpResult) {
                $scope.product_categories = httpResult.data;
            });
        }





    }
})();
